webpackJsonp([48],{

/***/ 2391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpresasNew_vue__ = __webpack_require__(3257);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e697a9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmpresasNew_vue__ = __webpack_require__(3770);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3750)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14e697a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpresasNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e697a9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmpresasNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/opensalud/EmpresasNew.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-14e697a9", Component.options)
  } else {
    hotAPI.reload("data-v-14e697a9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.req = exports.regex = exports.ref = exports.len = void 0;
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});

var _withParams = _interopRequireDefault(__webpack_require__(2488));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 2472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._setTarget = void 0;
exports.popParams = popParams;
exports.pushParams = pushParams;
exports.target = void 0;
exports.withParams = withParams;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var stack = [];
var target = null;
exports.target = target;

var _setTarget = function _setTarget(x) {
  exports.target = target = x;
};

exports._setTarget = _setTarget;

function pushParams() {
  if (target !== null) {
    stack.push(target);
  }

  exports.target = target = {};
}

function popParams() {
  var lastTarget = target;
  var newTarget = exports.target = target = stack.pop() || null;

  if (newTarget) {
    if (!Array.isArray(newTarget.$sub)) {
      newTarget.$sub = [];
    }

    newTarget.$sub.push(lastTarget);
  }

  return lastTarget;
}

function addParams(params) {
  if (_typeof(params) === 'object' && !Array.isArray(params)) {
    exports.target = target = _objectSpread(_objectSpread({}, target), params);
  } else {
    throw new Error('params must be an object');
  }
}

function withParamsDirect(params, validator) {
  return withParamsClosure(function (add) {
    return function () {
      add(params);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return validator.apply(this, args);
    };
  });
}

function withParamsClosure(closure) {
  var validator = closure(addParams);
  return function () {
    pushParams();

    try {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return validator.apply(this, args);
    } finally {
      popParams();
    }
  };
}

function withParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return withParamsDirect(paramsOrClosure, maybeValidator);
  }

  return withParamsClosure(paramsOrClosure);
}

/***/ }),

/***/ 2473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
exports.helpers = void 0;
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});

var _alpha = _interopRequireDefault(__webpack_require__(2487));

var _alphaNum = _interopRequireDefault(__webpack_require__(2490));

var _numeric = _interopRequireDefault(__webpack_require__(2491));

var _between = _interopRequireDefault(__webpack_require__(2492));

var _email = _interopRequireDefault(__webpack_require__(2493));

var _ipAddress = _interopRequireDefault(__webpack_require__(2494));

var _macAddress = _interopRequireDefault(__webpack_require__(2495));

var _maxLength = _interopRequireDefault(__webpack_require__(2496));

var _minLength = _interopRequireDefault(__webpack_require__(2497));

var _required = _interopRequireDefault(__webpack_require__(2498));

var _requiredIf = _interopRequireDefault(__webpack_require__(2499));

var _requiredUnless = _interopRequireDefault(__webpack_require__(2500));

var _sameAs = _interopRequireDefault(__webpack_require__(2501));

var _url = _interopRequireDefault(__webpack_require__(2502));

var _or = _interopRequireDefault(__webpack_require__(2503));

var _and = _interopRequireDefault(__webpack_require__(2504));

var _not = _interopRequireDefault(__webpack_require__(2505));

var _minValue = _interopRequireDefault(__webpack_require__(2506));

var _maxValue = _interopRequireDefault(__webpack_require__(2507));

var _integer = _interopRequireDefault(__webpack_require__(2508));

var _decimal = _interopRequireDefault(__webpack_require__(2509));

var helpers = _interopRequireWildcard(__webpack_require__(2465));

exports.helpers = helpers;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 2478:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NeuCardFunctions_vue__ = __webpack_require__(2482);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31fa0e7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NeuCardFunctions_vue__ = __webpack_require__(2530);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2528)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31fa0e7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NeuCardFunctions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31fa0e7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NeuCardFunctions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/ui/NeuCardFunctions.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-31fa0e7a", Component.options)
  } else {
    hotAPI.reload("data-v-31fa0e7a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NeuCardFunctions_vue__ = __webpack_require__(2478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseModal_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel_3d__ = __webpack_require__(2523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel_3d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_carousel_3d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_global_helpers__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'neu-cards-slider2',
  components: {
    NeuCard: __WEBPACK_IMPORTED_MODULE_0__NeuCardFunctions_vue__["default"],
    'carousel': function carousel() {
      return __webpack_require__.e/* import() */(146/* duplicate */).then(__webpack_require__.bind(null, 2598));
    },
    'carousel2': function carousel2() {
      return __webpack_require__.e/* import() */(155).then(__webpack_require__.bind(null, 2608));
    },
    'carousel-slide': function carouselSlide() {
      return __webpack_require__.e/* import() */(127/* duplicate */).then(__webpack_require__.bind(null, 2589));
    },
    'patient-signup-form': function patientSignupForm() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 2372));
    },
    'neu-card-function': function neuCardFunction() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 2478));
    },
    'neu-card-general': function neuCardGeneral() {
      return __webpack_require__.e/* import() */(125/* duplicate */).then(__webpack_require__.bind(null, 2552));
    },
    'neu-card-function-icon': function neuCardFunctionIcon() {
      return __webpack_require__.e/* import() */(152).then(__webpack_require__.bind(null, 2609));
    },
    'neu-card-big-text': function neuCardBigText() {
      return __webpack_require__.e/* import() */(126/* duplicate */).then(__webpack_require__.bind(null, 2588));
    },
    Carousel3d: __WEBPACK_IMPORTED_MODULE_2_vue_carousel_3d__["Carousel3d"],
    Slide: __WEBPACK_IMPORTED_MODULE_2_vue_carousel_3d__["Slide"],
    BaseModal: __WEBPACK_IMPORTED_MODULE_1__BaseModal_vue__["a" /* default */]

  },
  data: function data() {
    return {
      slide: 0,
      signInVisible: false,
      signUpVisible: false,
      windowWidth: window.innerWidth,
      cardDivided: window.innerWidth >= 1024 && window.innerWidth <= 1322 ? this.chunkArray(this.cards, 2) : this.chunkArray(this.cards, 3),
      sliding: null,
      inMx: __WEBPACK_IMPORTED_MODULE_3__helpers_global_helpers__["l" /* inMx */]
    };
  },

  methods: {
    onSlideStart: function onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd: function onSlideEnd(slide) {
      this.sliding = false;
    },
    chunkArray: function chunkArray(myArray, size) {
      var index = 0;
      var arrayLength = myArray.length;
      var tempArray = [];
      var myChunk = [];
      for (index = 0; index < arrayLength; index += size) {
        myChunk = myArray.slice(index, index + size);
        // Do something if you want with the group
        tempArray.push(myChunk);
      }

      return tempArray;
    }
  },
  props: {
    cards: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      require: false
    },
    title: {
      type: String,
      required: false
    },
    typeTitle: {
      type: String,
      required: false
    },
    subtitle: {
      type: String,
      required: false
    },
    blackTitle: {
      type: String,
      required: false
    },
    subtitleLines: Number,
    titleLines: Number,
    iconsColor: {
      type: String,
      required: false
    }
  },
  computed: {
    hasHeadingSlot: function hasHeadingSlot() {
      return !!this.$slots.heading;
    }
  }
});

/***/ }),

/***/ 2482:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_colours__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'neu-card-function',
  props: {
    src: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    subtitleLines: Number,
    titleLines: Number,
    iconColor: {
      type: String,
      required: false,
      default: __WEBPACK_IMPORTED_MODULE_0__constants_colours__["c" /* BLUE_COLOUR */]
    }
  },
  computed: {
    paddedTitle: function paddedTitle() {
      return this.titleLines ? '' + this.title + '<br>'.repeat(this.titleLines + 1) : this.title;
    },
    paddedSubtitle: function paddedSubtitle() {
      return this.subtitleLines ? '' + this.subtitle + '<br>'.repeat(this.subtitleLines + 1) : this.subtitle;
    }
  }
});

/***/ }),

/***/ 2483:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'ISO27001Logo'
});

/***/ }),

/***/ 2486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vuelidate = Vuelidate;
exports.validationMixin = exports.default = void 0;
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _params.withParams;
  }
});

var _vval = __webpack_require__(2510);

var _params = __webpack_require__(2472);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var NIL = function NIL() {
  return null;
};

var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isFunction(val) {
  return typeof val === 'function';
}

function isObject(val) {
  return val !== null && (_typeof(val) === 'object' || isFunction(val));
}

function isPromise(object) {
  return isObject(object) && isFunction(object.then);
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');

  for (var i = 0; i < path.length; i++) {
    if (obj && _typeof(obj) === 'object') {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';

function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      p: true,
      v: false
    }
  });
  promise.then(function (value) {
    asyncVm.p = false;
    asyncVm.v = value;
  }, function (error) {
    asyncVm.p = false;
    asyncVm.v = false;
    throw error;
  });
  asyncVm[__isVuelidateAsyncVm] = true;
  return asyncVm;
}

var validationGetters = {
  $invalid: function $invalid() {
    var _this = this;

    var proxy = this.proxy;
    return this.nestedKeys.some(function (nested) {
      return _this.refProxy(nested).$invalid;
    }) || this.ruleKeys.some(function (rule) {
      return !proxy[rule];
    });
  },
  $dirty: function $dirty() {
    var _this2 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.every(function (key) {
      return _this2.refProxy(key).$dirty;
    });
  },
  $anyDirty: function $anyDirty() {
    var _this3 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.some(function (key) {
      return _this3.refProxy(key).$anyDirty;
    });
  },
  $error: function $error() {
    return this.$dirty && !this.$pending && this.$invalid;
  },
  $anyError: function $anyError() {
    var _this4 = this;

    if (this.$error) return true;
    return this.nestedKeys.some(function (key) {
      return _this4.refProxy(key).$anyError;
    });
  },
  $pending: function $pending() {
    var _this5 = this;

    return this.ruleKeys.some(function (key) {
      return _this5.getRef(key).$pending;
    }) || this.nestedKeys.some(function (key) {
      return _this5.refProxy(key).$pending;
    });
  },
  $params: function $params() {
    var _this6 = this;

    var vals = this.validations;
    return _objectSpread(_objectSpread({}, buildFromKeys(this.nestedKeys, function (key) {
      return vals[key] && vals[key].$params || null;
    })), buildFromKeys(this.ruleKeys, function (key) {
      return _this6.getRef(key).$params;
    }));
  }
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var proxy = this.proxy;
  var method = newState ? '$touch' : '$reset';
  this.nestedKeys.forEach(function (key) {
    proxy[key][method]();
  });
}

var validationMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  },
  $flattenParams: function $flattenParams() {
    var proxy = this.proxy;
    var params = [];

    for (var key in this.$params) {
      if (this.isNested(key)) {
        var childParams = proxy[key].$flattenParams();

        for (var j = 0; j < childParams.length; j++) {
          childParams[j].path.unshift(key);
        }

        params = params.concat(childParams);
      } else {
        params.push({
          path: [],
          name: key,
          params: this.$params[key]
        });
      }
    }

    return params;
  }
};
var getterNames = Object.keys(validationGetters);
var methodNames = Object.keys(validationMethods);
var _cachedComponent = null;

var getComponent = function getComponent(Vue) {
  if (_cachedComponent) {
    return _cachedComponent;
  }

  var VBase = Vue.extend({
    computed: {
      refs: function refs() {
        var oldVval = this._vval;
        this._vval = this.children;
        (0, _vval.patchChildren)(oldVval, this._vval);
        var refs = {};

        this._vval.forEach(function (c) {
          refs[c.key] = c.vm;
        });

        return refs;
      }
    },
    beforeCreate: function beforeCreate() {
      this._vval = null;
    },
    beforeDestroy: function beforeDestroy() {
      if (this._vval) {
        (0, _vval.patchChildren)(this._vval);
        this._vval = null;
      }
    },
    methods: {
      getModel: function getModel() {
        return this.lazyModel ? this.lazyModel(this.prop) : this.model;
      },
      getModelKey: function getModelKey(key) {
        var model = this.getModel();

        if (model) {
          return model[key];
        }
      },
      hasIter: function hasIter() {
        return false;
      }
    }
  });
  var ValidationRule = VBase.extend({
    data: function data() {
      return {
        rule: null,
        lazyModel: null,
        model: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: {
      runRule: function runRule(parent) {
        var model = this.getModel();
        (0, _params.pushParams)();
        var rawOutput = this.rule.call(this.rootModel, model, parent);
        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;
        var rawParams = (0, _params.popParams)();
        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;
        return {
          output: output,
          params: params
        };
      }
    },
    computed: {
      run: function run() {
        var _this7 = this;

        var parent = this.lazyParentModel();

        var isArrayDependant = Array.isArray(parent) && parent.__ob__;

        if (isArrayDependant) {
          var arrayDep = parent.__ob__.dep;
          arrayDep.depend();
          var target = arrayDep.constructor.target;

          if (!this._indirectWatcher) {
            var Watcher = target.constructor;
            this._indirectWatcher = new Watcher(this, function () {
              return _this7.runRule(parent);
            }, null, {
              lazy: true
            });
          }

          var model = this.getModel();

          if (!this._indirectWatcher.dirty && this._lastModel === model) {
            this._indirectWatcher.depend();

            return target.value;
          }

          this._lastModel = model;

          this._indirectWatcher.evaluate();

          this._indirectWatcher.depend();
        } else if (this._indirectWatcher) {
          this._indirectWatcher.teardown();

          this._indirectWatcher = null;
        }

        return this._indirectWatcher ? this._indirectWatcher.value : this.runRule(parent);
      },
      $params: function $params() {
        return this.run.params;
      },
      proxy: function proxy() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return !!output.v;
        }

        return !!output;
      },
      $pending: function $pending() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return output.p;
        }

        return false;
      }
    },
    destroyed: function destroyed() {
      if (this._indirectWatcher) {
        this._indirectWatcher.teardown();

        this._indirectWatcher = null;
      }
    }
  });
  var Validation = VBase.extend({
    data: function data() {
      return {
        dirty: false,
        validations: null,
        lazyModel: null,
        model: null,
        prop: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: _objectSpread(_objectSpread({}, validationMethods), {}, {
      refProxy: function refProxy(key) {
        return this.getRef(key).proxy;
      },
      getRef: function getRef(key) {
        return this.refs[key];
      },
      isNested: function isNested(key) {
        return typeof this.validations[key] !== 'function';
      }
    }),
    computed: _objectSpread(_objectSpread({}, validationGetters), {}, {
      nestedKeys: function nestedKeys() {
        return this.keys.filter(this.isNested);
      },
      ruleKeys: function ruleKeys() {
        var _this8 = this;

        return this.keys.filter(function (k) {
          return !_this8.isNested(k);
        });
      },
      keys: function keys() {
        return Object.keys(this.validations).filter(function (k) {
          return k !== '$params';
        });
      },
      proxy: function proxy() {
        var _this9 = this;

        var keyDefs = buildFromKeys(this.keys, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this9.refProxy(key);
            }
          };
        });
        var getterDefs = buildFromKeys(getterNames, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this9[key];
            }
          };
        });
        var methodDefs = buildFromKeys(methodNames, function (key) {
          return {
            enumerable: false,
            configurable: true,
            get: function get() {
              return _this9[key];
            }
          };
        });
        var iterDefs = this.hasIter() ? {
          $iter: {
            enumerable: true,
            value: Object.defineProperties({}, _objectSpread({}, keyDefs))
          }
        } : {};
        return Object.defineProperties({}, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, keyDefs), iterDefs), {}, {
          $model: {
            enumerable: true,
            get: function get() {
              var parent = _this9.lazyParentModel();

              if (parent != null) {
                return parent[_this9.prop];
              } else {
                return null;
              }
            },
            set: function set(value) {
              var parent = _this9.lazyParentModel();

              if (parent != null) {
                parent[_this9.prop] = value;

                _this9.$touch();
              }
            }
          }
        }, getterDefs), methodDefs));
      },
      children: function children() {
        var _this10 = this;

        return [].concat(_toConsumableArray(this.nestedKeys.map(function (key) {
          return renderNested(_this10, key);
        })), _toConsumableArray(this.ruleKeys.map(function (key) {
          return renderRule(_this10, key);
        }))).filter(Boolean);
      }
    })
  });
  var GroupValidation = Validation.extend({
    methods: {
      isNested: function isNested(key) {
        return typeof this.validations[key]() !== 'undefined';
      },
      getRef: function getRef(key) {
        var vm = this;
        return {
          get proxy() {
            return vm.validations[key]() || false;
          }

        };
      }
    }
  });
  var EachValidation = Validation.extend({
    computed: {
      keys: function keys() {
        var model = this.getModel();

        if (isObject(model)) {
          return Object.keys(model);
        } else {
          return [];
        }
      },
      tracker: function tracker() {
        var _this11 = this;

        var trackBy = this.validations.$trackBy;
        return trackBy ? function (key) {
          return "".concat(getPath(_this11.rootModel, _this11.getModelKey(key), trackBy));
        } : function (x) {
          return "".concat(x);
        };
      },
      getModelLazy: function getModelLazy() {
        var _this12 = this;

        return function () {
          return _this12.getModel();
        };
      },
      children: function children() {
        var _this13 = this;

        var def = this.validations;
        var model = this.getModel();

        var validations = _objectSpread({}, def);

        delete validations['$trackBy'];
        var usedTracks = {};
        return this.keys.map(function (key) {
          var track = _this13.tracker(key);

          if (usedTracks.hasOwnProperty(track)) {
            return null;
          }

          usedTracks[track] = true;
          return (0, _vval.h)(Validation, track, {
            validations: validations,
            prop: key,
            lazyParentModel: _this13.getModelLazy,
            model: model[key],
            rootModel: _this13.rootModel
          });
        }).filter(Boolean);
      }
    },
    methods: {
      isNested: function isNested() {
        return true;
      },
      getRef: function getRef(key) {
        return this.refs[this.tracker(key)];
      },
      hasIter: function hasIter() {
        return true;
      }
    }
  });

  var renderNested = function renderNested(vm, key) {
    if (key === '$each') {
      return (0, _vval.h)(EachValidation, key, {
        validations: vm.validations[key],
        lazyParentModel: vm.lazyParentModel,
        prop: key,
        lazyModel: vm.getModel,
        rootModel: vm.rootModel
      });
    }

    var validations = vm.validations[key];

    if (Array.isArray(validations)) {
      var root = vm.rootModel;
      var refVals = buildFromKeys(validations, function (path) {
        return function () {
          return getPath(root, root.$v, path);
        };
      }, function (v) {
        return Array.isArray(v) ? v.join('.') : v;
      });
      return (0, _vval.h)(GroupValidation, key, {
        validations: refVals,
        lazyParentModel: NIL,
        prop: key,
        lazyModel: NIL,
        rootModel: root
      });
    }

    return (0, _vval.h)(Validation, key, {
      validations: validations,
      lazyParentModel: vm.getModel,
      prop: key,
      lazyModel: vm.getModelKey,
      rootModel: vm.rootModel
    });
  };

  var renderRule = function renderRule(vm, key) {
    return (0, _vval.h)(ValidationRule, key, {
      rule: vm.validations[key],
      lazyParentModel: vm.lazyParentModel,
      lazyModel: vm.getModel,
      rootModel: vm.rootModel
    });
  };

  _cachedComponent = {
    VBase: VBase,
    Validation: Validation
  };
  return _cachedComponent;
};

var _cachedVue = null;

function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;

  while (Vue.super) {
    Vue = Vue.super;
  }

  _cachedVue = Vue;
  return Vue;
}

var validateModel = function validateModel(model, validations) {
  var Vue = getVue(model);

  var _getComponent = getComponent(Vue),
      Validation = _getComponent.Validation,
      VBase = _getComponent.VBase;

  var root = new VBase({
    computed: {
      children: function children() {
        var vals = typeof validations === 'function' ? validations.call(model) : validations;
        return [(0, _vval.h)(Validation, '$v', {
          validations: vals,
          lazyParentModel: NIL,
          prop: '$v',
          model: model,
          rootModel: model
        })];
      }
    }
  });
  return root;
};

var validationMixin = {
  data: function data() {
    var vals = this.$options.validations;

    if (vals) {
      this._vuelidate = validateModel(this, vals);
    }

    return {};
  },
  beforeCreate: function beforeCreate() {
    var options = this.$options;
    var vals = options.validations;
    if (!vals) return;
    if (!options.computed) options.computed = {};
    if (options.computed.$v) return;

    options.computed.$v = function () {
      return this._vuelidate ? this._vuelidate.refs.$v.proxy : null;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this._vuelidate) {
      this._vuelidate.$destroy();

      this._vuelidate = null;
    }
  }
};
exports.validationMixin = validationMixin;

function Vuelidate(Vue) {
  Vue.mixin(validationMixin);
}

var _default = Vuelidate;
exports.default = _default;

/***/ }),

/***/ 2487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 2488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"PACKAGE_VERSION":"022025"}).BUILD === 'web' ? __webpack_require__(2489).withParams : __webpack_require__(2472).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 2489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 2490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 2491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 2492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 2493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var emailRegex = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 2494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 2495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 2496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 2497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 2498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = (0, _common.withParams)({
  type: 'required'
}, function (value) {
  if (typeof value === 'string') {
    return (0, _common.req)(value.trim());
  }

  return (0, _common.req)(value);
});

exports.default = _default;

/***/ }),

/***/ 2499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 2500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 2501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 2502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var urlRegex = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 2503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 2504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 2505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 2506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 2507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 2508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = (0, _common.regex)('integer', /(^[0-9]*$)|(^-[0-9]+$)/);

exports.default = _default;

/***/ }),

/***/ 2509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(2465);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 2510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.h = h;
exports.patchChildren = patchChildren;

function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameVval(oldVval, vval) {
  return vval.tag === oldVval.tag && vval.key === oldVval.key;
}

function createVm(vval) {
  var Vm = vval.tag;
  vval.vm = new Vm({
    data: vval.args
  });
}

function updateVval(vval) {
  var keys = Object.keys(vval.args);

  for (var i = 0; i < keys.length; i++) {
    keys.forEach(function (k) {
      vval.vm[k] = vval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i, key;
  var map = {};

  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }

  return map;
}

function updateChildren(oldCh, newCh) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVval = oldCh[0];
  var oldEndVval = oldCh[oldEndIdx];
  var newEndIdx = newCh.length - 1;
  var newStartVval = newCh[0];
  var newEndVval = newCh[newEndIdx];
  var oldKeyToIdx, idxInOld, elmToMove;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartVval)) {
      oldStartVval = oldCh[++oldStartIdx];
    } else if (isUndef(oldEndVval)) {
      oldEndVval = oldCh[--oldEndIdx];
    } else if (sameVval(oldStartVval, newStartVval)) {
      patchVval(oldStartVval, newStartVval);
      oldStartVval = oldCh[++oldStartIdx];
      newStartVval = newCh[++newStartIdx];
    } else if (sameVval(oldEndVval, newEndVval)) {
      patchVval(oldEndVval, newEndVval);
      oldEndVval = oldCh[--oldEndIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldStartVval, newEndVval)) {
      patchVval(oldStartVval, newEndVval);
      oldStartVval = oldCh[++oldStartIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldEndVval, newStartVval)) {
      patchVval(oldEndVval, newStartVval);
      oldEndVval = oldCh[--oldEndIdx];
      newStartVval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;

      if (isUndef(idxInOld)) {
        createVm(newStartVval);
        newStartVval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];

        if (sameVval(elmToMove, newStartVval)) {
          patchVval(elmToMove, newStartVval);
          oldCh[idxInOld] = undefined;
          newStartVval = newCh[++newStartIdx];
        } else {
          createVm(newStartVval);
          newStartVval = newCh[++newStartIdx];
        }
      }
    }
  }

  if (oldStartIdx > oldEndIdx) {
    addVvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

function addVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(vvals[startIdx]);
  }
}

function removeVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    var ch = vvals[startIdx];

    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchVval(oldVval, vval) {
  if (oldVval === vval) {
    return;
  }

  vval.vm = oldVval.vm;
  updateVval(vval);
}

function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addVvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeVvals(oldCh, 0, oldCh.length - 1);
  }
}

function h(tag, key, args) {
  return {
    tag: tag,
    key: key,
    args: args
  };
}

/***/ }),

/***/ 2516:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return gender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return phone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return onlyTrue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return afterToday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return afterDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return onlyText; });
/* unused harmony export hasNumber */
/* unused harmony export hasUpperCase */
/* unused harmony export hasLowerCase */
/* unused harmony export hasSpecialChar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return password; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_genders__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);
var _this=this;var gender=function gender(value){return value===__WEBPACK_IMPORTED_MODULE_0__constants_genders__["b" /* MALE */]||value===__WEBPACK_IMPORTED_MODULE_0__constants_genders__["a" /* FEMALE */];};var phone=__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('phone',/^\d+$/);/* export const password = helpers.regex('password', /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.=(){}\-_:,;^`[\]+¨´/¬])[A-Za-z\d@$!%*?&.=(){}\-_:,;^`[\]+¨´/¬]{8,}$/) */var onlyTrue=function onlyTrue(value){return value===true;};var afterToday=function afterToday(value){return new Date(value)>new Date();};var afterDate=function afterDate(date){return __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].withParams({type:'sameAs',value:date},function(value,parentVm){return new Date(value)>new Date(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].ref(date,_this,parentVm));});};var onlyText=__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('onlyText',/^[A-Za-zÀ-ÖØ-öø-ÿ\- ]+$/);var hasNumber=__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('hasNumber',/\d/);var hasUpperCase=__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('hasUpperCase',/[A-Z]/);var hasLowerCase=__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('hasLowerCase',/[a-z]/);var hasSpecialChar=__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["helpers"].regex('hasSpecialCharacter',/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/);var password={required:__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],minLength:Object(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["minLength"])(8),hasNumber:hasNumber,hasUpperCase:hasUpperCase,hasLowerCase:hasLowerCase,hasSpecialChar:hasSpecialChar};

/***/ }),

/***/ 2518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_forms_companies_contact_form_json__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang_en_forms_companies_contact_form_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lang_en_forms_companies_contact_form_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_forms_companies_contact_form_json__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang_pt_forms_companies_contact_form_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lang_pt_forms_companies_contact_form_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__repositories_MarketingRepository__ = __webpack_require__(2532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_GeographyRepository__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_base_ui_BaseAlert__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate__ = __webpack_require__(2486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__ = __webpack_require__(2473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__ = __webpack_require__(2516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_vue_select__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_base_forms_BaseSelect__ = __webpack_require__(515);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'CompaniesContactForm',
  mixins: [__WEBPACK_IMPORTED_MODULE_7_vuelidate__["validationMixin"]],
  components: {
    BaseAlert: __WEBPACK_IMPORTED_MODULE_6__components_base_ui_BaseAlert__["a" /* default */],
    BaseSelect: __WEBPACK_IMPORTED_MODULE_11__components_base_forms_BaseSelect__["default"]
  },
  i18n: {
    messages: {
      es: __WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json___default.a,
      en: __WEBPACK_IMPORTED_MODULE_1__lang_en_forms_companies_contact_form_json___default.a,
      mx: __WEBPACK_IMPORTED_MODULE_0__lang_es_forms_companies_contact_form_json___default.a,
      pt: __WEBPACK_IMPORTED_MODULE_2__lang_pt_forms_companies_contact_form_json___default.a
    }
  },
  props: {
    black: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('companies-contact-form.contact-us');
      }
    },
    platform: {
      type: String,
      required: false,
      default: 'Opensalud'
    },
    productName: {
      type: String,
      required: false,
      default: '360'
    },
    subtitle: {
      type: String,
      required: false
    },
    serviceType: {
      type: String,
      required: false,
      default: function _default() {
        return this.$t('companies-contact-form.service-type.digital-health');
      }
    },
    forIndividuals: {
      type: Boolean,
      required: false,
      default: false
    },
    forIndividualsOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    forCompaniesOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    showDescription: {
      type: Boolean,
      required: false,
      default: false
    },
    hideEmployeesNumber: {
      type: Boolean,
      required: false,
      default: false
    },
    showReason: {
      type: Boolean,
      required: false,
      default: false
    },
    showCollegiateNumber: {
      type: Boolean,
      required: false,
      default: false
    },
    hideWebsite: {
      type: Boolean,
      required: false,
      default: false
    },
    callbackPath: {
      type: String,
      required: false,
      default: '/contact/success'
    },
    isolated: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      form: {
        company: null,
        website: null,
        firstName: null,
        lastName: null,
        employeesNumber: null,
        phone: null,
        /*         state: null, */
        email: null,
        entityType: null,
        reason: null,
        collegiateNumber: null,
        privacyPolicy: null,
        country: null
      },
      formOptions: {
        entityTypes: [{ value: 'company', label: this.$t('companies-contact-form.form.entity-type.company') }, { value: 'individual', label: this.$t('companies-contact-form.form.entity-type.individual') }],
        employeesNum: [{
          value: '1',
          label: '1-10'
        }, {
          value: '2',
          label: '11-50'
        }, {
          value: '3',
          label: '51-200'
        }, {
          value: '4',
          label: '201-500'
        }, {
          value: '5',
          label: '501-1000'
        }, {
          value: '6',
          label: '1001-5000'
        }, {
          value: '7',
          label: '5001-10000'
        }, {
          value: '8',
          label: '10000+'
        }],
        provinces: []
      },
      formLegalConsentOptions: {
        privacyPolicy: false,
        subscriptionTypeId: '8323529'
      },
      countryOptions: [{
        value: 'España',
        label: this.$t('companies-contact-form.countries.spain')
      }, {
        value: 'México',
        label: this.$t('companies-contact-form.countries.mexico')
      }, {
        value: 'Portugal',
        label: this.$t('companies-contact-form.countries.portugal')
      }, {
        value: 'Brasil',
        label: this.$t('companies-contact-form.countries.brazil')
      }, {
        value: 'Colombia',
        label: this.$t('companies-contact-form.countries.colombia')
      }, {
        value: 'Italia',
        label: this.$t('companies-contact-form.countries.italy')
      }, {
        value: 'Otros',
        label: this.$t('companies-contact-form.countries.other')
      }]
    };
  },

  validations: {
    form: {
      company: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      firstName: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      phone: {},
      email: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      lastName: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      entityType: {},
      collegiateNumber: {},
      description: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      },
      reason: {},
      privacyPolicy: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"],
        onlyTrue: __WEBPACK_IMPORTED_MODULE_9__plugins_customValidators__["e" /* onlyTrue */]
      },
      employeesNumber: {
        numeric: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["numeric"]
      },
      country: {
        required: __WEBPACK_IMPORTED_MODULE_8_vuelidate_lib_validators__["required"]
      }
    }
  },
  methods: {
    sendContactForm: function sendContactForm() {
      var _this = this;

      this.$v.form.$touch();

      if (this.form.entityType == null && !this.forIndividuals && !this.forIndividualsOnly) {
        this.form.entityType = 'company';
      } else if (this.form.entityType == null && this.forIndividualsOnly) {
        this.form.entityType = 'individual';
      } else if (this.form.entityType == null) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-entity-type'));
        return;
      }
      if (!this.forIndividualsOnly && !this.form.company || !this.form.firstName || !this.form.lastName || !this.form.email || !this.forIndividualsOnly && !this.hideWebsite && !this.form.website || this.showCollegiateNumber && !this.form.collegiateNumber) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-fields'));
        return;
      }
      if (!this.form.privacyPolicy) {
        this.$store.dispatch('showDangerAlert', this.$t('companies-contact-form.form.errors.required-consent'));
        return;
      }

      this.form.trafficSource = this.$route.query.utm_source || 'organic';

      this.form.productName = this.productName;
      __WEBPACK_IMPORTED_MODULE_3__repositories_MarketingRepository__["a" /* default */].sendCompaniesContactForm(this.form).then(function (response) {
        /* this.$store.dispatch('showAlert', { text: this.$t('form.success'), variant: 'success' }) */
        // Show error alert if not 200 from server
        if (!response || !response.status || response.status !== 200) {
          _this.$store.dispatch('showDangerAlert', _this.$t('error.try-again'));
        } else {
          _this.$router.push(_this.callbackPath);
        }
      });
    },
    validateState: function validateState(prop) {
      /* eslint-disable no-unused-vars */
      var _$v$form$prop = this.$v.form[prop],
          $dirty = _$v$form$prop.$dirty,
          $error = _$v$form$prop.$error;

      return $dirty ? !$error : null;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_4__repositories_GeographyRepository__["a" /* default */].getStatesByCountry(28).then(function (response) {
      _this2.formOptions.provinces = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(response.data.sort(function (a, b) {
        return _this2.$i18nHelpers.normalize(a.name).localeCompare(_this2.$i18nHelpers.normalize(b.name));
      }), function (item) {
        var stateName = _this2.$i18nHelpers.normalize(item.name);
        return {
          value: stateName,
          label: stateName
        };
      });
    });
    if (this.forCompaniesOnly && !this.form.entityType) {
      this.form.entityType = 'company';
    } else if (this.forIndividualsOnly && !this.form.entityType) {
      this.form.entityType = 'individual';
    }

    /* 		GeographyRepository.getCountries().then(response => {
    			this.countryOptions = response.data
    		}) */
  },

  computed: {
    isCompany: function isCompany() {
      return (!this.forIndividuals || this.form.entityType === 'company') && !this.forIndividualsOnly || this.forCompaniesOnly;
    }
  }
});

/***/ }),

/***/ 2521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NeuCardsSlider2_vue__ = __webpack_require__(2481);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_291a644f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NeuCardsSlider2_vue__ = __webpack_require__(2531);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2526)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NeuCardsSlider2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_291a644f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NeuCardsSlider2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/ui/NeuCardsSlider2.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-291a644f", Component.options)
  } else {
    hotAPI.reload("data-v-291a644f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2523:
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "0976":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("55dd");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6ff6d360", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0b44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_0__);

var autoplay = {
  props: {
    /**
     * Flag to enable autoplay
     */
    autoplay: {
      type: Boolean,
      default: false
    },

    /**
     * Time elapsed before next slide
     */
    autoplayTimeout: {
      type: Number,
      default: 2000
    },

    /**
     * Flag to pause autoplay on hover
     */
    autoplayHoverPause: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      autoplayInterval: null
    };
  },
  destroyed: function destroyed() {
    if (!process.server) {
      this.pauseAutoplay();
      this.$el.removeEventListener('mouseenter', this.pauseAutoplay);
      this.$el.removeEventListener('mouseleave', this.startAutoplay);
    }
  },
  methods: {
    pauseAutoplay: function pauseAutoplay() {
      if (this.autoplayInterval) {
        this.autoplayInterval = clearInterval(this.autoplayInterval);
      }
    },
    startAutoplay: function startAutoplay() {
      var _this = this;

      if (this.autoplay) {
        this.autoplayInterval = setInterval(function () {
          _this.dir === 'ltr' ? _this.goPrev() : _this.goNext();
        }, this.autoplayTimeout);
      }
    }
  },
  mounted: function mounted() {
    if (!process.server && this.autoplayHoverPause) {
      this.$el.addEventListener('mouseenter', this.pauseAutoplay);
      this.$el.addEventListener('mouseleave', this.startAutoplay);
      this.startAutoplay();
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (autoplay);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "24fb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "2877":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var forEach = __webpack_require__("17c2");

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "4362":
/***/ (function(module, exports, __webpack_require__) {

exports.nextTick = function nextTick(fn) {
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    setTimeout(function () {
        fn.apply(null, args);
    }, 0);
};

exports.platform = exports.arch = 
exports.execPath = exports.title = 'browser';
exports.pid = 1;
exports.browser = true;
exports.env = {};
exports.argv = [];

exports.binding = function (name) {
	throw new Error('No such module. (Possibly not yet loaded)')
};

(function () {
    var cwd = '/';
    var path;
    exports.cwd = function () { return cwd };
    exports.chdir = function (dir) {
        if (!path) path = __webpack_require__("df7c");
        cwd = path.resolve(dir, cwd);
    };
})();

exports.exit = exports.kill = 
exports.umask = exports.dlopen = 
exports.uptime = exports.memoryUsage = 
exports.uvCounters = function() {};
exports.features = {};


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "52f3":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".carousel-3d-container[data-v-07917306]{min-height:1px;width:100%;position:relative;z-index:0;overflow:hidden;margin:20px auto;box-sizing:border-box}.carousel-3d-slider[data-v-07917306]{position:relative;margin:0 auto;transform-style:preserve-3d;perspective:1000px}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "55dd":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".carousel-3d-controls[data-v-05517ad0]{position:absolute;top:50%;height:0;margin-top:-30px;left:0;width:100%;z-index:1000}.next[data-v-05517ad0],.prev[data-v-05517ad0]{width:60px;position:absolute;z-index:1010;font-size:60px;height:60px;line-height:60px;color:#333;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-decoration:none;top:0}.next[data-v-05517ad0]:hover,.prev[data-v-05517ad0]:hover{cursor:pointer;opacity:.7}.prev[data-v-05517ad0]{left:10px;text-align:left}.next[data-v-05517ad0]{right:10px;text-align:right}.disabled[data-v-05517ad0],.disabled[data-v-05517ad0]:hover{opacity:.2;cursor:default}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.5',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5701":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5faf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("361ae300", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5faf":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".carousel-3d-slide{position:absolute;opacity:0;visibility:hidden;overflow:hidden;top:0;border-radius:1px;border-color:#000;border-color:rgba(0,0,0,.4);border-style:solid;background-size:cover;background-color:#ccc;display:block;margin:0;box-sizing:border-box;text-align:left}.carousel-3d-slide img{width:100%}.carousel-3d-slide.current{opacity:1!important;visibility:visible!important;transform:none!important;z-index:999}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "800d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Carousel3d_vue_vue_type_style_index_0_id_07917306_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aa2e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Carousel3d_vue_vue_type_style_index_0_id_07917306_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Carousel3d_vue_vue_type_style_index_0_id_07917306_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Carousel3d_vue_vue_type_style_index_0_id_07917306_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9c17":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Slide_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5701");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Slide_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Slide_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Slide_vue_vue_type_style_index_0_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a221":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4de4");
/* harmony import */ var core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("a9e3");
/* harmony import */ var core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_constructor__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _carousel_3d_mixins_autoplay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("0b44");
/* harmony import */ var _carousel_3d_Controls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("b17f");


//
//
//
//
//
//
//
//
//
//



var noop = function noop() {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'carousel3d',
  components: {
    Controls: _carousel_3d_Controls__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"]
  },
  props: {
    count: {
      type: [Number, String],
      default: 0
    },
    perspective: {
      type: [Number, String],
      default: 35
    },
    display: {
      type: [Number, String],
      default: 5
    },
    loop: {
      type: Boolean,
      default: true
    },
    animationSpeed: {
      type: [Number, String],
      default: 500
    },
    dir: {
      type: String,
      default: 'rtl'
    },
    width: {
      type: [Number, String],
      default: 360
    },
    height: {
      type: [Number, String],
      default: 270
    },
    border: {
      type: [Number, String],
      default: 1
    },
    space: {
      type: [Number, String],
      default: 'auto'
    },
    startIndex: {
      type: [Number, String],
      default: 0
    },
    clickable: {
      type: Boolean,
      default: true
    },
    disable3d: {
      type: Boolean,
      default: false
    },
    minSwipeDistance: {
      type: Number,
      default: 10
    },
    inverseScaling: {
      type: [Number, String],
      default: 300
    },
    controlsVisible: {
      type: Boolean,
      default: false
    },
    controlsPrevHtml: {
      type: String,
      default: '&lsaquo;'
    },
    controlsNextHtml: {
      type: String,
      default: '&rsaquo;'
    },
    controlsWidth: {
      type: [String, Number],
      default: 50
    },
    controlsHeight: {
      type: [String, Number],
      default: 50
    },
    onLastSlide: {
      type: Function,
      default: noop
    },
    onSlideChange: {
      type: Function,
      default: noop
    },
    bias: {
      type: String,
      default: 'left'
    },
    onMainSlideClick: {
      type: Function,
      default: noop
    },
    oneDirectional: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      viewport: 0,
      currentIndex: 0,
      total: 0,
      dragOffsetX: 0,
      dragStartX: 0,
      dragOffsetY: 0,
      dragStartY: 0,
      mousedown: false,
      zIndex: 998
    };
  },
  mixins: [_carousel_3d_mixins_autoplay__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"]],
  watch: {
    count: function count() {
      this.computeData();
    }
  },
  computed: {
    isLastSlide: function isLastSlide() {
      return this.currentIndex === this.total - 1;
    },
    isFirstSlide: function isFirstSlide() {
      return this.currentIndex === 0;
    },
    isNextPossible: function isNextPossible() {
      return !(!this.loop && this.isLastSlide);
    },
    isPrevPossible: function isPrevPossible() {
      return !(!this.loop && this.isFirstSlide);
    },
    slideWidth: function slideWidth() {
      var vw = this.viewport;
      var sw = parseInt(this.width) + parseInt(this.border, 10) * 2;
      return vw < sw && process.browser ? vw : sw;
    },
    slideHeight: function slideHeight() {
      var sw = parseInt(this.width, 10) + parseInt(this.border, 10) * 2;
      var sh = parseInt(parseInt(this.height) + this.border * 2, 10);
      var ar = this.calculateAspectRatio(sw, sh);
      return this.slideWidth / ar;
    },
    visible: function visible() {
      var v = this.display > this.total ? this.total : this.display;
      return v;
    },
    hasHiddenSlides: function hasHiddenSlides() {
      return this.total > this.visible;
    },
    leftIndices: function leftIndices() {
      var n = (this.visible - 1) / 2;
      n = this.bias.toLowerCase() === 'left' ? Math.ceil(n) : Math.floor(n);
      var indices = [];

      for (var m = 1; m <= n; m++) {
        indices.push(this.dir === 'ltr' ? (this.currentIndex + m) % this.total : (this.currentIndex - m) % this.total);
      }

      return indices;
    },
    rightIndices: function rightIndices() {
      var n = (this.visible - 1) / 2;
      n = this.bias.toLowerCase() === 'right' ? Math.ceil(n) : Math.floor(n);
      var indices = [];

      for (var m = 1; m <= n; m++) {
        indices.push(this.dir === 'ltr' ? (this.currentIndex - m) % this.total : (this.currentIndex + m) % this.total);
      }

      return indices;
    },
    leftOutIndex: function leftOutIndex() {
      var n = (this.visible - 1) / 2;
      n = this.bias.toLowerCase() === 'left' ? Math.ceil(n) : Math.floor(n);
      n++;

      if (this.dir === 'ltr') {
        return this.total - this.currentIndex - n <= 0 ? -parseInt(this.total - this.currentIndex - n) : this.currentIndex + n;
      } else {
        return this.currentIndex - n;
      }
    },
    rightOutIndex: function rightOutIndex() {
      var n = (this.visible - 1) / 2;
      n = this.bias.toLowerCase() === 'right' ? Math.ceil(n) : Math.floor(n);
      n++;

      if (this.dir === 'ltr') {
        return this.currentIndex - n;
      } else {
        return this.total - this.currentIndex - n <= 0 ? -parseInt(this.total - this.currentIndex - n, 10) : this.currentIndex + n;
      }
    }
  },
  methods: {
    /**
     * Go to next slide
     */
    goNext: function goNext() {
      if (this.isNextPossible) {
        this.isLastSlide ? this.goSlide(0) : this.goSlide(this.currentIndex + 1);
      }
    },

    /**
     * Go to previous slide
     */
    goPrev: function goPrev() {
      if (this.isPrevPossible) {
        this.isFirstSlide ? this.goSlide(this.total - 1) : this.goSlide(this.currentIndex - 1);
      }
    },

    /**
     * Go to slide
     * @param  {String} index of slide where to go
     */
    goSlide: function goSlide(index) {
      var _this = this;

      this.currentIndex = index < 0 || index > this.total - 1 ? 0 : index;

      if (this.isLastSlide) {
        if (this.onLastSlide !== noop) {
          console.warn('onLastSlide deprecated, please use @last-slide');
        }

        this.onLastSlide(this.currentIndex);
        this.$emit('last-slide', this.currentIndex);
      }

      this.$emit('before-slide-change', this.currentIndex);
      setTimeout(function () {
        return _this.animationEnd();
      }, this.animationSpeed);
    },

    /**
     * Go to slide far slide
     */
    goFar: function goFar(index) {
      var _this2 = this;

      var diff = index === this.total - 1 && this.isFirstSlide ? -1 : index - this.currentIndex;

      if (this.isLastSlide && index === 0) {
        diff = 1;
      }

      var diff2 = diff < 0 ? -diff : diff;
      var timeBuff = 0;
      var i = 0;

      while (i < diff2) {
        i += 1;
        var timeout = diff2 === 1 ? 0 : timeBuff;
        setTimeout(function () {
          return diff < 0 ? _this2.goPrev(diff2) : _this2.goNext(diff2);
        }, timeout);
        timeBuff += this.animationSpeed / diff2;
      }
    },

    /**
     * Trigger actions when animation ends
     */
    animationEnd: function animationEnd() {
      if (this.onSlideChange !== noop) {
        console.warn('onSlideChange deprecated, please use @after-slide-change');
      }

      this.onSlideChange(this.currentIndex);
      this.$emit('after-slide-change', this.currentIndex);
    },

    /**
     * Trigger actions when mouse is released
     * @param  {Object} e The event object
     */
    handleMouseup: function handleMouseup() {
      this.mousedown = false;
      this.dragOffsetX = 0;
      this.dragOffsetY = 0;
    },

    /**
     * Trigger actions when mouse is pressed
     * @param  {Object} e The event object
     */
    handleMousedown: function handleMousedown(e) {
      if (!e.touches) {
        e.preventDefault();
      }

      this.mousedown = true;
      this.dragStartX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX;
      this.dragStartY = 'ontouchstart' in window ? e.touches[0].clientY : e.clientY;
    },

    /**
     * Trigger actions when mouse is pressed and then moved (mouse drag)
     * @param  {Object} e The event object
     */
    handleMousemove: function handleMousemove(e) {
      if (!this.mousedown) {
        return;
      }

      var eventPosX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX;
      var eventPosY = 'ontouchstart' in window ? e.touches[0].clientY : e.clientY;
      var deltaX = this.dragStartX - eventPosX;
      var deltaY = this.dragStartY - eventPosY;
      this.dragOffsetX = deltaX;
      this.dragOffsetY = deltaY; // If the swipe is more significant on the Y axis, do not move the slides because this is a scroll gesture

      if (Math.abs(this.dragOffsetY) > Math.abs(this.dragOffsetX)) {
        return;
      }

      if (this.dragOffsetX > this.minSwipeDistance) {
        this.handleMouseup();
        this.goNext();
      } else if (this.dragOffsetX < -this.minSwipeDistance) {
        this.handleMouseup();
        this.goPrev();
      }
    },

    /**
     * A mutation observer is used to detect changes to the containing node
     * in order to keep the magnet container in sync with the height its reference node.
     */
    attachMutationObserver: function attachMutationObserver() {
      var _this3 = this;

      var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

      if (MutationObserver) {
        var config = {
          attributes: true,
          childList: true,
          characterData: true
        };
        this.mutationObserver = new MutationObserver(function () {
          _this3.$nextTick(function () {
            _this3.computeData();
          });
        });

        if (this.$el) {
          this.mutationObserver.observe(this.$el, config);
        }
      }
    },
    detachMutationObserver: function detachMutationObserver() {
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    },

    /**
     * Get the number of slides
     * @return {Number} Number of slides
     */
    getSlideCount: function getSlideCount() {
      if (this.$slots.default !== undefined) {
        return this.$slots.default.filter(function (value) {
          return value.tag !== void 0;
        }).length;
      }

      return 0;
    },

    /**
     * Calculate slide with and keep defined aspect ratio
     * @return {Number} Aspect ratio number
     */
    calculateAspectRatio: function calculateAspectRatio(width, height) {
      return Math.min(width / height);
    },

    /**
     * Re-compute the number of slides and current slide
     */
    computeData: function computeData(firstRun) {
      this.total = this.getSlideCount();

      if (firstRun || this.currentIndex >= this.total) {
        this.currentIndex = parseInt(this.startIndex) > this.total - 1 ? this.total - 1 : parseInt(this.startIndex);
      }

      this.viewport = this.$el.clientWidth;
    },
    setSize: function setSize() {
      this.$el.style.cssText += 'height:' + this.slideHeight + 'px;';
      this.$el.childNodes[0].style.cssText += 'width:' + this.slideWidth + 'px;' + ' height:' + this.slideHeight + 'px;';
    }
  },
  mounted: function mounted() {
    if (!process.server) {
      this.computeData(true);
      this.attachMutationObserver();
      window.addEventListener('resize', this.setSize);

      if ('ontouchstart' in window) {
        this.$el.addEventListener('touchstart', this.handleMousedown);
        this.$el.addEventListener('touchend', this.handleMouseup);
        this.$el.addEventListener('touchmove', this.handleMousemove);
      } else {
        this.$el.addEventListener('mousedown', this.handleMousedown);
        this.$el.addEventListener('mouseup', this.handleMouseup);
        this.$el.addEventListener('mousemove', this.handleMousemove);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!process.server) {
      this.detachMutationObserver();

      if ('ontouchstart' in window) {
        this.$el.removeEventListener('touchmove', this.handleMousemove);
      } else {
        this.$el.removeEventListener('mousemove', this.handleMousemove);
      }

      window.removeEventListener('resize', this.setSize);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "aa2e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("52f3");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4baddf4c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "b17f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b1b00db-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/carousel-3d/Controls.vue?vue&type=template&id=05517ad0&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-3d-controls"},[_c('a',{staticClass:"prev",class:{ disabled: !_vm.parent.isPrevPossible },style:(("width: " + _vm.width + "px; height: " + _vm.height + "px; line-height: " + _vm.height + "px;")),attrs:{"href":"#","aria-label":"Previous slide"},on:{"click":function($event){$event.preventDefault();return _vm.parent.goPrev()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.prevHtml)}})]),_c('a',{staticClass:"next",class:{ disabled: !_vm.parent.isNextPossible },style:(("width: " + _vm.width + "px; height: " + _vm.height + "px; line-height: " + _vm.height + "px;")),attrs:{"href":"#","aria-label":"Next slide"},on:{"click":function($event){$event.preventDefault();return _vm.parent.goNext()}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.nextHtml)}})])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/carousel-3d/Controls.vue?vue&type=template&id=05517ad0&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/carousel-3d/Controls.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Controlsvue_type_script_lang_js_ = ({
  name: 'controls',
  props: {
    /**
     * Width in pixels of the navigation buttons
     */
    width: {
      type: [String, Number],
      default: 50
    },

    /**
     * Height in pixels of the navigation buttons
     */
    height: {
      type: [String, Number],
      default: 60
    },

    /**
     * Text content of the navigation prev button
     */
    prevHtml: {
      type: String,
      default: '&lsaquo;'
    },

    /**
     * Text content of the navigation next button
     */
    nextHtml: {
      type: String,
      default: '&rsaquo;'
    }
  },
  data: function data() {
    return {
      parent: this.$parent
    };
  }
});
// CONCATENATED MODULE: ./src/carousel-3d/Controls.vue?vue&type=script&lang=js&
 /* harmony default export */ var carousel_3d_Controlsvue_type_script_lang_js_ = (Controlsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/carousel-3d/Controls.vue?vue&type=style&index=0&id=05517ad0&scoped=true&lang=css&
var Controlsvue_type_style_index_0_id_05517ad0_scoped_true_lang_css_ = __webpack_require__("fa60");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/carousel-3d/Controls.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  carousel_3d_Controlsvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "05517ad0",
  null
  
)

/* harmony default export */ var Controls = __webpack_exports__["a"] = (component.exports);

/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "df7c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("4362")))

/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "fa60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Controls_vue_vue_type_style_index_0_id_05517ad0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0976");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Controls_vue_vue_type_style_index_0_id_05517ad0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Controls_vue_vue_type_style_index_0_id_05517ad0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Controls_vue_vue_type_style_index_0_id_05517ad0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "Carousel3d", function() { return /* reexport */ Carousel3d; });
__webpack_require__.d(__webpack_exports__, "Slide", function() { return /* reexport */ Slide; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b1b00db-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/carousel-3d/Slide.vue?vue&type=template&id=1067a9f8&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-3d-slide",class:_vm.computedClasses,style:(_vm.slideStyle),on:{"click":function($event){return _vm.goTo()}}},[_vm._t("default",null,{"index":_vm.index,"isCurrent":_vm.isCurrent,"leftIndex":_vm.leftIndex,"rightIndex":_vm.rightIndex})],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/carousel-3d/Slide.vue?vue&type=template&id=1067a9f8&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/carousel-3d/Slide.vue?vue&type=script&lang=js&





//
//
//
//
//
//
/* harmony default export */ var Slidevue_type_script_lang_js_ = ({
  name: 'slide',
  props: {
    index: {
      type: Number
    }
  },
  data: function data() {
    return {
      parent: this.$parent,
      styles: {},
      zIndex: 999
    };
  },
  computed: {
    isCurrent: function isCurrent() {
      return this.index === this.parent.currentIndex;
    },
    leftIndex: function leftIndex() {
      if (this.parent.oneDirectional && this.getSideIndex(this.parent.leftIndices) > this.parent.currentIndex - 1) return -1;
      return this.getSideIndex(this.parent.leftIndices);
    },
    rightIndex: function rightIndex() {
      if (this.parent.oneDirectional && this.getSideIndex(this.parent.rightIndices) > this.parent.total - this.parent.currentIndex - 2) return -1;
      return this.getSideIndex(this.parent.rightIndices);
    },
    slideStyle: function slideStyle() {
      var styles = {};

      if (!this.isCurrent) {
        var lIndex = this.leftIndex;
        var rIndex = this.rightIndex;

        if (rIndex >= 0 || lIndex >= 0) {
          styles = rIndex >= 0 ? this.calculatePosition(rIndex, true, this.zIndex) : this.calculatePosition(lIndex, false, this.zIndex);
          styles.opacity = 1;
          styles.visibility = 'visible';
        }

        if (this.parent.hasHiddenSlides) {
          if (this.matchIndex(this.parent.leftOutIndex)) {
            styles = this.calculatePosition(this.parent.leftIndices.length - 1, false, this.zIndex);
          } else if (this.matchIndex(this.parent.rightOutIndex)) {
            styles = this.calculatePosition(this.parent.rightIndices.length - 1, true, this.zIndex);
          }
        }
      }

      return Object.assign(styles, {
        'border-width': this.parent.border + 'px',
        'width': this.parent.slideWidth + 'px',
        'height': this.parent.slideHeight + 'px',
        'transition': ' transform ' + this.parent.animationSpeed + 'ms, ' + '               opacity ' + this.parent.animationSpeed + 'ms, ' + '               visibility ' + this.parent.animationSpeed + 'ms'
      });
    },
    computedClasses: function computedClasses() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, "left-".concat(this.leftIndex + 1), this.leftIndex >= 0), _defineProperty(_ref, "right-".concat(this.rightIndex + 1), this.rightIndex >= 0), _defineProperty(_ref, 'current', this.isCurrent), _ref;
    }
  },
  methods: {
    getSideIndex: function getSideIndex(array) {
      var _this = this;

      var index = -1;
      array.forEach(function (pos, i) {
        if (_this.matchIndex(pos)) {
          index = i;
        }
      });
      return index;
    },
    matchIndex: function matchIndex(index) {
      return index >= 0 ? this.index === index : this.parent.total + index === this.index;
    },
    calculatePosition: function calculatePosition(i, positive, zIndex) {
      var z = !this.parent.disable3d ? parseInt(this.parent.inverseScaling) + (i + 1) * 100 : 0;
      var y = !this.parent.disable3d ? parseInt(this.parent.perspective) : 0;
      var leftRemain = this.parent.space === 'auto' ? parseInt((i + 1) * (this.parent.width / 1.5), 10) : parseInt((i + 1) * this.parent.space, 10);
      var transform = positive ? 'translateX(' + leftRemain + 'px) translateZ(-' + z + 'px) ' + 'rotateY(-' + y + 'deg)' : 'translateX(-' + leftRemain + 'px) translateZ(-' + z + 'px) ' + 'rotateY(' + y + 'deg)';
      var top = this.parent.space === 'auto' ? 0 : parseInt((i + 1) * this.parent.space);
      return {
        transform: transform,
        top: top,
        zIndex: zIndex - (Math.abs(i) + 1)
      };
    },
    goTo: function goTo() {
      if (!this.isCurrent) {
        if (this.parent.clickable === true) {
          this.parent.goFar(this.index);
        }
      } else {
        var index = this.index;
        this.parent.onMainSlideClick({
          index: index
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./src/carousel-3d/Slide.vue?vue&type=script&lang=js&
 /* harmony default export */ var carousel_3d_Slidevue_type_script_lang_js_ = (Slidevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/carousel-3d/Slide.vue?vue&type=style&index=0&lang=css&
var Slidevue_type_style_index_0_lang_css_ = __webpack_require__("9c17");

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__("2877");

// CONCATENATED MODULE: ./src/carousel-3d/Slide.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  carousel_3d_Slidevue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Slide = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"4b1b00db-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/carousel-3d/Carousel3d.vue?vue&type=template&id=07917306&scoped=true&
var Carousel3dvue_type_template_id_07917306_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel-3d-container",style:({height: this.slideHeight + 'px'})},[_c('div',{staticClass:"carousel-3d-slider",style:({width: this.slideWidth + 'px', height: this.slideHeight + 'px'})},[_vm._t("default")],2),(_vm.controlsVisible)?_c('controls',{attrs:{"next-html":_vm.controlsNextHtml,"prev-html":_vm.controlsPrevHtml,"width":_vm.controlsWidth,"height":_vm.controlsHeight}}):_vm._e()],1)}
var Carousel3dvue_type_template_id_07917306_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/carousel-3d/Carousel3d.vue?vue&type=template&id=07917306&scoped=true&

// EXTERNAL MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/carousel-3d/Carousel3d.vue?vue&type=script&lang=js&
var Carousel3dvue_type_script_lang_js_ = __webpack_require__("a221");

// CONCATENATED MODULE: ./src/carousel-3d/Carousel3d.vue?vue&type=script&lang=js&
 /* harmony default export */ var carousel_3d_Carousel3dvue_type_script_lang_js_ = (Carousel3dvue_type_script_lang_js_["a" /* default */]); 
// EXTERNAL MODULE: ./src/carousel-3d/Carousel3d.vue?vue&type=style&index=0&id=07917306&scoped=true&lang=css&
var Carousel3dvue_type_style_index_0_id_07917306_scoped_true_lang_css_ = __webpack_require__("800d");

// CONCATENATED MODULE: ./src/carousel-3d/Carousel3d.vue






/* normalize component */

var Carousel3d_component = Object(componentNormalizer["a" /* default */])(
  carousel_3d_Carousel3dvue_type_script_lang_js_,
  Carousel3dvue_type_template_id_07917306_scoped_true_render,
  Carousel3dvue_type_template_id_07917306_scoped_true_staticRenderFns,
  false,
  null,
  "07917306",
  null
  
)

/* harmony default export */ var Carousel3d = (Carousel3d_component.exports);
// CONCATENATED MODULE: ./src/carousel-3d/index.js



var carousel_3d_install = function install(Vue) {
  Vue.component('carousel3d', Carousel3d);
  Vue.component('slide', Slide);
};

/* harmony default export */ var carousel_3d = ({
  install: carousel_3d_install
});

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (carousel_3d);



/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ });
//# sourceMappingURL=carousel-3d.common.js.map

/***/ }),

/***/ 2526:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2527);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("0fa6bc50", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-291a644f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NeuCardsSlider2.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-291a644f\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NeuCardsSlider2.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2527:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\n.neu-card{border-radius:23px;display:block\n}\n.neu-card:not(.black){-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee\n}\n.neu-card.black{-webkit-box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784)\n}\n@media only screen and (min-width: 1024px){\n.neu-card{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card{padding:0rem 5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card{padding:7rem;width:100%;max-width:none\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card{padding:5rem 3rem\n}\n}\n.neu-card-icon{border-radius:23px;display:block\n}\n.neu-card-icon:not(.black){-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee\n}\n.neu-card-icon.black{-webkit-box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784)\n}\n@media only screen and (min-width: 1024px){\n.neu-card-icon{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-icon{padding:0rem 5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-icon{padding:7rem;width:100%;max-width:none\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-icon{padding:5rem 3rem\n}\n}\n.neu-card-price{border-radius:23px;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.neu-card-price:not(.black){-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee\n}\n.neu-card-price.black{-webkit-box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784)\n}\n@media only screen and (min-width: 1024px){\n.neu-card-price{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-price{padding:0rem 5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-price{padding:7rem;width:100%;max-width:none\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-price{padding:5rem 3rem\n}\n}\n/deep/.cert-icons{margin-left:auto !important\n}\n/deep/.cert-icons div{margin-top:auto;margin-bottom:auto;margin-right:5rem;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n/deep/.cert-icons div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n@media only screen and (max-width: 575px){\n/deep/.cert-icons div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n/deep/.cert-icons div img{margin:auto;float:left;-o-object-fit:cover;object-fit:cover\n}\n/deep/.cert-icons div img.vertical{height:140px\n}\n@media only screen and (max-width: 575px){\n/deep/.cert-icons div img.vertical{height:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n/deep/.cert-icons div img.vertical{height:70px\n}\n}\n/deep/.cert-icons div img:not(.vertical){width:140px\n}\n@media only screen and (max-width: 575px){\n/deep/.cert-icons div img:not(.vertical){width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n/deep/.cert-icons div img:not(.vertical){width:70px\n}\n}\n/deep/.cert-icons-footer{margin-left:auto !important\n}\n/deep/.cert-icons-footer div{margin-top:auto;margin-bottom:auto;margin-right:5rem;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n/deep/.cert-icons-footer div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n@media only screen and (max-width: 575px){\n/deep/.cert-icons-footer div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n/deep/.cert-icons-footer div img{margin:auto;float:left;-o-object-fit:cover;object-fit:cover\n}\n/deep/.cert-icons-footer div img.first-icon{width:130px;height:auto\n}\n@media only screen and (max-width: 575px){\n/deep/.cert-icons-footer div img.first-icon{width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n/deep/.cert-icons-footer div img.first-icon{width:70px\n}\n}\n/deep/.cert-icons-footer div img.last-icon{width:150px;height:auto\n}\n@media only screen and (max-width: 575px){\n/deep/.cert-icons-footer div img.last-icon{width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n/deep/.cert-icons-footer div img.last-icon{width:70px\n}\n}\n/deep/.cert-icons-footer div img.middle-icon{width:80px;height:auto\n}\n@media only screen and (max-width: 575px){\n/deep/.cert-icons-footer div img.middle-icon{width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n/deep/.cert-icons-footer div img.middle-icon{width:70px\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.my-0-manuel{margin-top:0 !important;margin-bottom:0 !important\n}\n}\n@media only screen and (min-width: 1024px){\n.mb-xl-6{margin-bottom:3rem !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.mobile-font{font-size:20px !important\n}\n}\n@media only screen and (max-width: 575px){\n.mobile-font{font-size:23px !important;padding-right:1rem;padding-left:1rem\n}\n}\n@media only screen and (min-width: 1367px){\n.neu-cards-slider-general .d-touch-screens-block{display:block !important\n}\n}\n@media only screen and (min-width: 1367px){\n.neu-cards-slider-general .d-touch-screens-none{display:none !important\n}\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (min-width: 1024px) and (max-width: 575px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn{padding-right:3rem !important;padding-left:3rem !important\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 1024px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn{padding:0 4rem\n}\n.neu-cards-slider-general .neu-cards-slider .card-ctn.less-cols{padding:0 1rem !important\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 1024px) and (min-width: 700px) and (max-width: 1550px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn{padding:0 2rem !important\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider-general .neu-cards-slider .card-ctn{padding:0 2rem\n}\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn .neu-card{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 1024px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn .neu-card{padding:1rem;min-height:300px;max-width:350px\n}\n.neu-cards-slider-general .neu-cards-slider .card-ctn .neu-card svg{width:60%\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider-general .neu-cards-slider .card-ctn .neu-card{padding:0rem;min-height:300px;max-width:250px\n}\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn .neu-card-rates{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 1024px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn .neu-card-rates{padding:5rem;min-height:500px;max-width:220px\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider-general .neu-cards-slider .card-ctn .neu-card-rates{padding:0rem 5rem;min-height:300px;max-width:250px\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 575px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn{padding-right:3rem !important;padding-left:3rem !important;padding-bottom:3rem !important\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider-general .neu-cards-slider .card-ctn .neu-card{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.neu-cards-slider-general .neu-cards-slider .card-ctn .neu-card-rates{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 2528:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2529);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("53b3ea36", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31fa0e7a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NeuCardFunctions.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31fa0e7a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./NeuCardFunctions.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2529:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-31fa0e7a]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-31fa0e7a],.slide-down-leave-active[data-v-31fa0e7a]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-31fa0e7a],.slide-down-leave-to[data-v-31fa0e7a]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-31fa0e7a],.slide-fade-left-leave-active[data-v-31fa0e7a]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-31fa0e7a],.slide-fade-left-leave-to[data-v-31fa0e7a]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-31fa0e7a]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-31fa0e7a],.fade-leave-to[data-v-31fa0e7a]{opacity:0\n}\n.img-icon[data-v-31fa0e7a]{margin:auto;float:left;-o-object-fit:cover;object-fit:cover\n}\n.img-icon.vertical[data-v-31fa0e7a]{height:150px\n}\n@media only screen and (max-width: 575px){\n.img-icon.vertical[data-v-31fa0e7a]{height:150px\n}\n}\n.img-icon[data-v-31fa0e7a]:not(.vertical){width:100px\n}\n@media only screen and (max-width: 575px){\n.img-icon[data-v-31fa0e7a]:not(.vertical){width:150px\n}\n}\n.neu-card-ctn .neu-card[data-v-31fa0e7a]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-transition-duration:999999999999999s;transition-duration:999999999999999s;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px solid #eee;border-radius:23px\n}\n@media only screen and (max-width: 575px){\n.neu-card-ctn .neu-card[data-v-31fa0e7a]{height:30rem;width:15rem\n}\n}\n@media screen and (min-width: 500px) and (max-width: 1200px){\n.neu-card-ctn .neu-card[data-v-31fa0e7a]{height:25rem\n}\n}\n.neu-card-ctn .neu-card[data-v-31fa0e7a]:hover{-webkit-transition-duration:9999999999999999s;transition-duration:9999999999999999s\n}\n@media only screen and (min-width: 1024px){\n.neu-card-ctn .neu-card[data-v-31fa0e7a]:hover{padding:4rem 6rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-ctn .neu-card[data-v-31fa0e7a]:hover{padding:0rem 4rem\n}\n}\n.neu-card-ctn .neu-card .icon-width[data-v-31fa0e7a]{width:7rem;margin-block-end:0rem;-webkit-margin-after:1rem\n}\n@media screen and (min-width: 500px) and (max-width: 1200px){\n.neu-card-ctn .neu-card .icon-width[data-v-31fa0e7a]{-webkit-margin-before:3rem\n}\n}\n.neu-card-ctn .neu-card span[data-v-31fa0e7a]{display:block\n}\n.neu-card-ctn .subtitle-card[data-v-31fa0e7a]{width:14rem;height:7rem;text-align:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-top:0rem;margin-bottom:0rem;margin-block-end:0rem;-webkit-margin-after:3rem\n}\n.neu-card-ctn .subtitle-card p[data-v-31fa0e7a]{color:#3238C4;font-weight:bold;font-size:1.25rem;white-space:normal\n}\n", ""]);

// exports


/***/ }),

/***/ 2530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "neu-card-ctn mx-auto" }, [
    _c(
      "div",
      { staticClass: "neu-card mx-auto" },
      [
        _vm.src !=
          "/static-appopensalud/img/icons/morillas-svg-icons/Logo/logo-receta.png" &&
        _vm.src !=
          "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
          ? _c("base-icon", {
              staticClass: "icon-width",
              attrs: {
                src: _vm.src,
                blue: "",
                fullWidth: "",
                shadow: "",
                color: _vm.iconColor
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.src ==
        "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
          ? _c("img", {
              staticClass: " vertical img-icon icon-width",
              staticStyle: { width: "7.7em", height: "7.7em" },
              attrs: {
                src:
                  "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle-card" }, [
          _c("p", { domProps: { innerHTML: _vm._s(_vm.paddedTitle) } }),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.paddedSubtitle) } })
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31fa0e7a", esExports)
  }
}

/***/ }),

/***/ 2531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "neu-cards-slider-general" },
    [
      _c(
        "b-row",
        { staticClass: "centered d-flex neu-cards-slider-general-funct" },
        [
          _vm.signUpVisible
            ? _c(
                "base-modal",
                {
                  ref: "signUpModal",
                  attrs: { title: _vm.$t("sign-up"), hideClose: "" },
                  model: {
                    value: _vm.signUpVisible,
                    callback: function($$v) {
                      _vm.signUpVisible = $$v
                    },
                    expression: "signUpVisible"
                  }
                },
                [
                  _c("patient-signup-form", {
                    attrs: {
                      callback: function() {
                        _vm.signUpVisible = false
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.blackTitle != null || _vm.hasHeadingSlot
            ? _c(
                "b-col",
                {
                  staticClass: "text-center pt-lg-0 d-inline-block",
                  attrs: { cols: "12" }
                },
                [
                  !_vm.hasHeadingSlot
                    ? _c("div", { staticClass: "my-auto" }, [
                        _vm.blackTitle
                          ? _c(
                              "h2",
                              {
                                staticClass:
                                  "mobile-font mx-3 mx-md-0 mt-5 mt-md-0 my-md-5",
                                class: {
                                  "my-5":
                                    _vm.typeTitle != "principal" &&
                                    !_vm.$uiHelpers.isFullMobile
                                },
                                staticStyle: {
                                  display: "inline-block",
                                  "font-size": "35px"
                                }
                              },
                              [_vm._v(_vm._s(_vm.blackTitle))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.typeTitle === "principal" ? _c("br") : _vm._e(),
                        _vm.title != null
                          ? _c(
                              "h3",
                              {
                                staticClass: "mobile-font",
                                class: { "my-5": !_vm.$uiHelpers.isFullMobile },
                                staticStyle: {
                                  "font-size": "35px",
                                  display: "inline-block"
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.title))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.subtitle != null
                          ? _c(
                              "h4",
                              {
                                staticClass: "mobile-font",
                                class: {
                                  "my-2 mx-5": !_vm.$uiHelpers.isFullMobile,
                                  "mx-2": !_vm.$uiHelpers.isFullMobile
                                },
                                staticStyle: {
                                  "font-size": "25px",
                                  display: "inline-block",
                                  color: "#3238C4"
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.subtitle))]
                            )
                          : _vm._e()
                      ])
                    : _c("div", [_vm._t("heading")], 2)
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("carousel2", {
            staticClass: "d-none d-touch-screens-block",
            attrs: {
              cards: _vm.cards.filter(function(e) {
                return (
                  (!e.inMx && (e.es || true) === true) ||
                  (_vm.inMx && e.mx === true)
                )
              }),
              type: _vm.type,
              iconColor: _vm.iconsColor
            }
          }),
          _vm._v(" "),
          _c(
            "carousel-3d",
            {
              staticClass: "d-block d-touch-screens-none mb-5 mb-md-0",
              attrs: { height: 350, border: 0 }
            },
            _vm._l(
              _vm.cards.filter(function(e) {
                return (
                  (!_vm.inMx && (e.es || true) === true) ||
                  (_vm.inMx && e.mx === true)
                )
              }),
              function(professional, i) {
                return _c("slide", {
                  key: i,
                  staticStyle: { "background-color": "transparent" },
                  attrs: { index: i },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var index = ref.index
                          var isCurrent = ref.isCurrent
                          var leftIndex = ref.leftIndex
                          var rightIndex = ref.rightIndex
                          return [
                            professional.type == 0
                              ? _c("neu-card-general", {
                                  class: {
                                    current: isCurrent,
                                    onLeft: leftIndex >= 0,
                                    onRight: rightIndex >= 0
                                  },
                                  attrs: {
                                    "data-index": index,
                                    src: professional.src,
                                    title: professional.title,
                                    subtitle: professional.subtitle,
                                    titleLines: 1,
                                    subtitleLines: 1
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            professional.type == 2
                              ? _c("neu-card-general", {
                                  class: {
                                    current: isCurrent,
                                    onLeft: leftIndex >= 0,
                                    onRight: rightIndex >= 0
                                  },
                                  attrs: {
                                    "data-index": index,
                                    src: professional.src,
                                    link: professional.link,
                                    title: professional.title,
                                    titleLines: professional.titleLines,
                                    iconColor: _vm.iconsColor
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            professional.type == null
                              ? _c("neu-card-big-text", {
                                  class: {
                                    current: isCurrent,
                                    onLeft: leftIndex >= 0,
                                    onRight: rightIndex >= 0
                                  },
                                  attrs: {
                                    "data-index": index,
                                    src: professional.src,
                                    title: professional.title,
                                    subtitle: professional.subtitle,
                                    titleLines: professional.titleLines,
                                    subtitleLines: professional.subtitleLines,
                                    iconColor: _vm.iconsColor
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              }
            ),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-291a644f", esExports)
  }
}

/***/ }),

/***/ 2532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OPENLEGAL_PROMOTION_NEWSLETTER_TYPE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
var client=__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;var OPENLEGAL_PROMOTION_NEWSLETTER_TYPE='OPENLEGAL_PROMOTION';/* harmony default export */ __webpack_exports__["a"] = ({sendCompaniesContactForm:function sendCompaniesContactForm(form){return client.post('/mk/companies-contact-form',form);},subscribePromotionOpenlegal:function subscribePromotionOpenlegal(email){return client.post('/mk/newsletter-registrations',{email:email,type:OPENLEGAL_PROMOTION_NEWSLETTER_TYPE});}});

/***/ }),

/***/ 2533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ISO27001Logo_vue__ = __webpack_require__(2483);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f87180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ISO27001Logo_vue__ = __webpack_require__(2536);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2534)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ISO27001Logo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f87180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ISO27001Logo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/ISO27001Logo.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-28f87180", Component.options)
  } else {
    hotAPI.reload("data-v-28f87180", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2534:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2535);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("731791b8", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-28f87180\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ISO27001Logo.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-28f87180\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ISO27001Logo.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2535:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n", ""]);

// exports


/***/ }),

/***/ 2536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href:
            "https://opensaludes.sharepoint.com/:b:/s/General2/EewHuG8R5t1BnvqeB1acUVUBNx-umeNWcdrRgYyuwB2dug?e=tfdM2E",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticClass: "vertical middle-icon",
          attrs: {
            alt: "ISO 27001 OCA logo",
            src:
              "/static-appopensalud/img/icons/morillas-svg-icons/Logo/27001.png"
          }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28f87180", esExports)
  }
}

/***/ }),

/***/ 2559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompaniesContactForm_vue__ = __webpack_require__(2518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fafd3b9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompaniesContactForm_vue__ = __webpack_require__(2562);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2560)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fafd3b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompaniesContactForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fafd3b9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompaniesContactForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/forms/CompaniesContactForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6fafd3b9", Component.options)
  } else {
    hotAPI.reload("data-v-6fafd3b9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2560:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2561);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("411d22f2", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6fafd3b9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CompaniesContactForm.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6fafd3b9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CompaniesContactForm.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2561:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-6fafd3b9]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-6fafd3b9],.slide-down-leave-active[data-v-6fafd3b9]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-6fafd3b9],.slide-down-leave-to[data-v-6fafd3b9]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-6fafd3b9],.slide-fade-left-leave-active[data-v-6fafd3b9]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-6fafd3b9],.slide-fade-left-leave-to[data-v-6fafd3b9]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-6fafd3b9]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-6fafd3b9],.fade-leave-to[data-v-6fafd3b9]{opacity:0\n}\n@media only screen and (max-width: 575px){\n[data-v-6fafd3b9] h3{font-size:2rem !important\n}\n.content[data-v-6fafd3b9]{padding-top:0\n}\n}\n.mobile[data-v-6fafd3b9]{padding-bottom:0rem !important\n}\n.mobile-subtitle[data-v-6fafd3b9]{padding-top:0rem !important;padding-bottom:0rem !important\n}\n.mobile-form[data-v-6fafd3b9]{padding-top:0rem !important;padding-bottom:0rem !important\n}\n.mobile-maxheight[data-v-6fafd3b9]{min-height:77vh !important\n}\n.section[data-v-6fafd3b9]{text-align:left\n}\n.section[data-v-6fafd3b9]:not(.h-auto){min-height:100dvh\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section[data-v-6fafd3b9]:not(.h-auto){min-height:60dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section .content[data-v-6fafd3b9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section .content[data-v-6fafd3b9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n.section h3[data-v-6fafd3b9]{line-height:1.2;font-size:3rem\n}\n@media only screen and (max-width: 575px){\n.section h3[data-v-6fafd3b9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section h3[data-v-6fafd3b9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.section h3[data-v-6fafd3b9]{font-size:1.5rem\n}\n}\n.section h5[data-v-6fafd3b9]{font-size:2rem\n}\n@media only screen and (min-width: 1024px){\n.section h5[data-v-6fafd3b9]{padding:0 25rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section h5[data-v-6fafd3b9]{padding:0 10rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section h5[data-v-6fafd3b9]{padding:0rem\n}\n}\n.section .subtitle[data-v-6fafd3b9]{width:100%\n}\n@media only screen and (min-width: 1024px){\n.section .subtitle[data-v-6fafd3b9]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section .subtitle[data-v-6fafd3b9]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.section .subtitle[data-v-6fafd3b9]{margin-top:1rem\n}\n}\n.section .subtitle p[data-v-6fafd3b9]{font-size:1.25rem\n}\n.section .col-bg[data-v-6fafd3b9]{height:100%;min-height:60dvh;background-size:cover\n}\n.section .quote[data-v-6fafd3b9]{text-transform:uppercase;font-size:.8rem\n}\n.section .quote p[data-v-6fafd3b9]{letter-spacing:.75px\n}\n.section .quote span[data-v-6fafd3b9]{font-weight:bold;color:#8A8A8A\n}\n@media only screen and (min-width: 1024px){\n.section[data-v-6fafd3b9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.section[data-v-6fafd3b9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section[data-v-6fafd3b9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section[data-v-6fafd3b9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.section[data-v-6fafd3b9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.section[data-v-6fafd3b9]{padding-right:2rem;padding-left:2rem\n}\n}\n.bg-black[data-v-6fafd3b9]{background-color:#1D1D1E;color:#eee\n}\n.no-full-height[data-v-6fafd3b9]{min-height:initial !important\n}\n.os-bg-white[data-v-6fafd3b9]{background-color:#E4E4E4 !important\n}\n", ""]);

// exports


/***/ }),

/***/ 2562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "mx-auto",
      class: {
        "section-invert": _vm.black && !_vm.isolated,
        section: !_vm.black && !_vm.isolated,
        "py-10": !_vm.black,
        "mobile-maxheight": _vm.$uiHelpers.isMobile
      },
      attrs: { id: "contact-form" }
    },
    [
      _c(
        "b-col",
        {
          class: {
            "bg-black": _vm.black,
            "my-lg-auto mt-sm-auto pr-lg-5 mb-4 mb-sm-0": true,
            mobile: _vm.$uiHelpers.isMobile
          },
          attrs: { lg: "6", md: "12" }
        },
        [
          _c("h3", [_vm._v(" " + _vm._s(_vm.title))]),
          _vm._v(" "),
          _vm.subtitle
            ? _c(
                "p",
                { class: { "mobile-subtitle": _vm.$uiHelpers.isMobile } },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.subtitle ||
                          _vm.$t("companies-contact-form.subtitle", {
                            serviceType: _vm.serviceType
                          })
                      ) +
                      "\n\t\t\t"
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "pl-lg-5",
          class: {
            "mobile-form": _vm.$uiHelpers.isMobile,
            "os-bg-white": _vm.black,
            "my-auto": !_vm.black
          },
          attrs: { lg: "6", md: "12" }
        },
        [
          _c("div", { class: { "py-sm-10 pl-sm-5": _vm.black } }, [
            _c(
              "div",
              [
                (_vm.forIndividuals ||
                  (!_vm.forIndividuals && !_vm.forIndividualsOnly)) &&
                !_vm.forCompaniesOnly
                  ? _c("base-select", {
                      staticClass: "mb-4",
                      attrs: {
                        state: _vm.validateState("entityType"),
                        options: _vm.formOptions.entityTypes,
                        placeholder: _vm.$t(
                          "companies-contact-form.form.select-single-or-business"
                        )
                      },
                      model: {
                        value: _vm.form.entityType,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "entityType", $$v)
                        },
                        expression: "form.entityType"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "pr-lg-2", attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.validateState("firstName"),
                            placeholder: _vm.$t(
                              "companies-contact-form.form.name"
                            )
                          },
                          model: {
                            value: _vm.form.firstName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "firstName", $$v)
                            },
                            expression: "form.firstName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.validateState("lastName"),
                            placeholder: _vm.$t(
                              "companies-contact-form.form.surnames"
                            )
                          },
                          model: {
                            value: _vm.form.lastName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "lastName", $$v)
                            },
                            expression: "form.lastName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _vm.isCompany
                      ? _c(
                          "b-col",
                          {
                            staticClass: "pr-lg-2",
                            attrs: { lg: "6", md: "12" }
                          },
                          [
                            _c("base-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "companies-contact-form.form.company"
                                ),
                                state: _vm.validateState("company")
                              },
                              model: {
                                value: _vm.form.company,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "company", $$v)
                                },
                                expression: "form.company"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.validateState("email"),
                            placeholder: _vm.$t(
                              "companies-contact-form.form.email"
                            )
                          },
                          model: {
                            value: _vm.form.email,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "pr-lg-2", attrs: { lg: "6", md: "12" } },
                      [
                        _c("base-input", {
                          attrs: {
                            state: _vm.validateState("phone"),
                            placeholder: _vm.$t(
                              "companies-contact-form.form.phone-number"
                            )
                          },
                          model: {
                            value: _vm.form.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "phone", $$v)
                            },
                            expression: "form.phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.isCompany && !_vm.hideEmployeesNumber
                      ? _c(
                          "b-col",
                          { attrs: { lg: "6", md: "12" } },
                          [
                            _c("base-input", {
                              attrs: {
                                state: _vm.validateState("employeesNumber"),
                                placeholder: _vm.$t(
                                  "companies-contact-form.form.employees-number"
                                )
                              },
                              model: {
                                value: _vm.form.employeesNumber,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "employeesNumber", $$v)
                                },
                                expression: "form.employeesNumber"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _vm.countryOptions
                          ? _c("base-select", {
                              staticClass: "mb-4",
                              attrs: {
                                placeholder: _vm.$t("signupOH.country"),
                                options: _vm.countryOptions,
                                clearable: false
                              },
                              model: {
                                value: _vm.form.country,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "country", $$v)
                                },
                                expression: "form.country"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showCollegiateNumber
                  ? _c("base-input", {
                      attrs: {
                        state: _vm.validateState("collegiateNumber"),
                        placeholder: _vm.$t(
                          "companies-contact-form.form.collegiateNumber"
                        )
                      },
                      model: {
                        value: _vm.form.collegiateNumber,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "collegiateNumber", $$v)
                        },
                        expression: "form.collegiateNumber"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showDescription
                  ? _c("base-textarea", {
                      attrs: {
                        state: _vm.validateState("description"),
                        placeholder: _vm.$t("openlegal.explain-case")
                      },
                      model: {
                        value: _vm.form.description,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "description", $$v)
                        },
                        expression: "form.description"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.showReason
                  ? _c("base-textarea", {
                      staticClass: "mt-2",
                      attrs: {
                        state: _vm.validateState("reason"),
                        placeholder: _vm.$t(
                          "companies-contact-form.form.form-reason"
                        )
                      },
                      model: {
                        value: _vm.form.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "reason", $$v)
                        },
                        expression: "form.reason"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "companies-contact-form.form.disclaimers.personal",
                          { platform: _vm.platform }
                        )
                      ) +
                      "\n\t\t\t\t\t"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "base-checkbox",
                  {
                    attrs: { state: _vm.validateState("privacyPolicy") },
                    model: {
                      value: _vm.form.privacyPolicy,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "privacyPolicy", $$v)
                      },
                      expression: "form.privacyPolicy"
                    }
                  },
                  [
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "companies-contact-form.form.disclaimers.privacy"
                          )
                        )
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    attrs: { outline: "", black: "" },
                    on: { click: _vm.sendContactForm }
                  },
                  [_vm._v(_vm._s(_vm.$t("send")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fafd3b9", esExports)
  }
}

/***/ }),

/***/ 2741:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 2852:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoundedCheckIcon_vue__ = __webpack_require__(2741);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc0c787_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoundedCheckIcon_vue__ = __webpack_require__(2855);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2853)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bc0c787"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoundedCheckIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bc0c787_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoundedCheckIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/icons/RoundedCheckIcon.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4bc0c787", Component.options)
  } else {
    hotAPI.reload("data-v-4bc0c787", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2853:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2854);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("e04f0a30", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4bc0c787\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RoundedCheckIcon.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4bc0c787\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./RoundedCheckIcon.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2854:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-4bc0c787]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-4bc0c787],.slide-down-leave-active[data-v-4bc0c787]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-4bc0c787],.slide-down-leave-to[data-v-4bc0c787]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-4bc0c787],.slide-fade-left-leave-active[data-v-4bc0c787]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-4bc0c787],.slide-fade-left-leave-to[data-v-4bc0c787]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-4bc0c787]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-4bc0c787],.fade-leave-to[data-v-4bc0c787]{opacity:0\n}\n.mdi-check-circle-outline[data-v-4bc0c787]::before{content:\"\\F05E1\"\n}\n.mdi[data-v-4bc0c787]:before{display:inline-block;font:normal normal normal 24px/1 \"Material Design Icons\";font-size:inherit;text-rendering:auto;line-height:inherit;-webkit-font-smoothing:antialiased\n}\n", ""]);

// exports


/***/ }),

/***/ 2855:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("i", {
    staticClass: "v-icon mdi mdi-check-circle-outline",
    staticStyle: { "font-size": "28px", color: "grey" },
    attrs: { "aria-hidden": "true" }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bc0c787", esExports)
  }
}

/***/ }),

/***/ 3257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_base_ui_NeuCardsSlider2_vue__ = __webpack_require__(2521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_layout_mixin__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_colours__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_base_icons_RoundedCheckIcon_vue__ = __webpack_require__(2852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_forms_CompaniesContactForm_vue__ = __webpack_require__(2559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utils_ISO27001Logo_vue__ = __webpack_require__(2533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_global_helpers__ = __webpack_require__(43);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_layout_mixin__["a" /* default */]],
  components: {
    NeuCardsSlider2: __WEBPACK_IMPORTED_MODULE_1__components_base_ui_NeuCardsSlider2_vue__["a" /* default */],
    RoundedCheckIcon: __WEBPACK_IMPORTED_MODULE_4__components_base_icons_RoundedCheckIcon_vue__["a" /* default */],
    BBadge: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["b" /* BBadge */],
    CompaniesContactForm: __WEBPACK_IMPORTED_MODULE_5__components_forms_CompaniesContactForm_vue__["a" /* default */],
    ISO27001Logo: __WEBPACK_IMPORTED_MODULE_6__components_utils_ISO27001Logo_vue__["a" /* default */]
  },
  data: function data() {
    return {
      inMx: __WEBPACK_IMPORTED_MODULE_7__helpers_global_helpers__["l" /* inMx */],
      BLUE_COLOUR: __WEBPACK_IMPORTED_MODULE_3__constants_colours__["c" /* BLUE_COLOUR */],
      /* wellnessCards: [
        {
          title: this.$t('os360-empresas.wellness-services.cards.1.title'),
          subtitle: this.$t('os360-empresas.wellness-services.cards.1.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/yoga.svg',
          type: 0
        },
        {
          title: this.$t('os360-empresas.wellness-services.cards.2.title'),
          subtitle: this.$t('os360-empresas.wellness-services.cards.2.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/wellbeing-mindset.svg',
          type: 0
        },
        {
          title: this.$t('os360-empresas.wellness-services.cards.3.title'),
          subtitle: this.$t('os360-empresas.wellness-services.cards.3.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/environment-wellbeing.svg',
          type: 0
        },
        {
          title: this.$t('os360-empresas.wellness-services.cards.4.title'),
          subtitle: this.$t('os360-empresas.wellness-services.cards.4.subtitle'),
          src: '/static-appopensalud/img/icons/morillas-svg-icons/primary/social-wellbeing.svg',
          type: 0
        }
      ], */
      blocks: [{
        title: this.$t('os360-empresas.blocks.teleconsultation.title'),
        description: this.$t('os360-empresas.blocks.teleconsultation.description'),
        img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/medic.svg'
      }, {
        title: this.$t('os360-empresas.blocks.wellness.title'),
        description: this.$t('os360-empresas.blocks.wellness.description'),
        img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/hand-holding-heart.svg'
      }, {
        title: this.$t('os360-empresas.blocks.evaluate-your-health.title'),
        description: this.$t('os360-empresas.blocks.evaluate-your-health.description'),
        img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/self-test.svg'
      }, {
        title: this.$t('os360-empresas.blocks.healthy-habits.title'),
        description: this.$t('os360-empresas.blocks.healthy-habits.description'),
        img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/habits-food.svg'
      }, {
        title: this.$t('os360-empresas.blocks.opensaludpass.title'),
        description: this.$t('os360-empresas.blocks.opensaludpass.description'),
        img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/creditcard.svg'
      }, {
        title: this.$t('os360-empresas.blocks.digital-phisiotherapy.title'),
        description: this.$t('os360-empresas.blocks.digital-phisiotherapy.description'),
        img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/fisio-digital.svg'
        /*         {
                  title: this.$t('os360-empresas.blocks.healthy-community.title'),
                  description: this.$t('os360-empresas.blocks.healthy-community.description'),
                  img: '/static-appopensalud/img/icons/morillas-svg-icons/primary/healthy-community.svg'
                } */
      }],
      companyLogos: [{
        name: 'AON',
        logo: '/static-appopensalud/img/logos/aon.svg',
        width: '40%'
      }, {
        name: 'Barcelo',
        logo: '/static-appopensalud/img/logos/barcelo.svg',
        width: '65%'
      }, {
        name: 'IKEA',
        logo: '/static-appopensalud/img/logos/_IKEA.svg',
        width: '40%'
      }, {
        name: 'Mahou San Miguel',
        logo: '/static-appopensalud/img/logos/msm.svg'
      }, {
        name: 'Scania',
        logo: '/static-appopensalud/img/logos/scania.png',
        width: '65%'
      }, {
        name: 'Siemens',
        logo: '/static-appopensalud/img/logos/siemens.svg'
      }, {
        name: 'Santander',
        logo: '/static-appopensalud/img/logos/santander.svg',
        width: '65%'
      }, {
        name: 'Novo Nordisk',
        logo: '/static-appopensalud/img/logos/novo-nordisk.svg'
      }, {
        name: 'Iveco',
        logo: '/static-appopensalud/img/logos/IVECO_2.svg'
      }, {
        name: 'Loreal',
        logo: '/static-appopensalud/img/logos/loreal.svg',
        width: '65%'
      }]
    };
  },

  methods: {
    goToContactForm: function goToContactForm() {
      this.goToSection('contact-form', 1500);
    },
    goToSection: function goToSection(section) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

      this.$scrollTo('#' + section, duration, {
        container: 'body',
        easing: 'ease-in',
        lazy: false,
        force: true,
        cancelable: true,
        onStart: function onStart(element) {
          // scrolling started
        },
        onDone: function onDone(element) {
          // scrolling is done
        },
        onCancel: function onCancel() {
          // scrolling has been interrupted
        },

        x: false,
        y: true
      });
    },
    goTo360SignIn: function goTo360SignIn() {
      window.location.href = this.$helpers.get360AppUrl('inicio-sesion');
    }
  },
  computed: {
    groupsOfLogos: function groupsOfLogos() {
      // Divide array in groups of 5
      return this.companyLogos.reduce(function (acc, curr, i) {
        if (!(i % 5)) {
          acc.push([]);
        }
        acc[acc.length - 1].push(curr);
        return acc;
      }, []);
    }
  }
});

/***/ }),

/***/ 3750:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3751);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("70f92cfc", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14e697a9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmpresasNew.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14e697a9\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./EmpresasNew.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3751:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-14e697a9]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-14e697a9],.slide-down-leave-active[data-v-14e697a9]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-14e697a9],.slide-down-leave-to[data-v-14e697a9]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-14e697a9],.slide-fade-left-leave-active[data-v-14e697a9]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-14e697a9],.slide-fade-left-leave-to[data-v-14e697a9]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-14e697a9]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-14e697a9],.fade-leave-to[data-v-14e697a9]{opacity:0\n}\n.navbar[data-v-14e697a9]{z-index:1000;width:100%;-webkit-box-pack:justify !important;-ms-flex-pack:justify !important;justify-content:space-between !important\n}\n@media only screen and (min-width: 1024px){\n.navbar[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.navbar[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.navbar[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.navbar[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.navbar[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.navbar[data-v-14e697a9]{padding-top:1rem\n}\n}\n@media only screen and (min-width: 1024px){\n.navbar .nav-item.nav-lang[data-v-14e697a9]{margin-right:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar ul.navbar-nav[data-v-14e697a9]:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);display:contents\n}\n.navbar .nav-item[data-v-14e697a9]{font-size:.875rem\n}\n.navbar .nav-item button[data-v-14e697a9]{border:0px;background-color:transparent;margin:0;font-weight:bold;font-size:.875rem;padding:0\n}\n}\n@media only screen and (max-width: 575px){\n.navbar ul.navbar-nav[data-v-14e697a9]:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);display:contents\n}\n.navbar .nav-item[data-v-14e697a9]{font-size:.875rem\n}\n.navbar .nav-item button[data-v-14e697a9]{border:0px;background-color:transparent;margin:0;font-weight:bold;font-size:.875rem;padding:0\n}\n}\n@media only screen and (max-height: 575px) and (orientation: landscape){\n.navbar ul.navbar-nav[data-v-14e697a9]:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);display:contents\n}\n.navbar .nav-item[data-v-14e697a9]{font-size:.875rem\n}\n.navbar .nav-item button[data-v-14e697a9]{border:0px;background-color:transparent;margin:0;font-weight:bold;font-size:.875rem;padding:0\n}\n}\n.navbar-brand-img[data-v-14e697a9]{width:175px\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar-brand-img[data-v-14e697a9]{width:175px\n}\n}\n@media only screen and (max-width: 575px){\n.navbar-brand-img[data-v-14e697a9]{width:140px !important\n}\n}\n@media only screen and (min-width: 1024px){\n.ctm-container[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.ctm-container[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.ctm-container[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.ctm-container[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.ctm-container[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.ctm-container[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n.section-invert[data-v-14e697a9]{text-align:left;background-color:#1D1D1E\n}\n.section-invert[data-v-14e697a9]:not(.h-auto){min-height:100dvh\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert[data-v-14e697a9]:not(.h-auto){min-height:60dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n.section-invert h3[data-v-14e697a9]{line-height:1.2;font-size:3rem\n}\n@media only screen and (max-width: 575px){\n.section-invert h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.section-invert h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n.section-invert h5[data-v-14e697a9]{font-size:2rem\n}\n@media only screen and (min-width: 1024px){\n.section-invert h5[data-v-14e697a9]{padding:0 25rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert h5[data-v-14e697a9]{padding:0 10rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert h5[data-v-14e697a9]{padding:0rem\n}\n}\n.section-invert .subtitle[data-v-14e697a9]{width:100%\n}\n@media only screen and (min-width: 1024px){\n.section-invert .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n.section-invert .subtitle p[data-v-14e697a9]{font-size:1.25rem\n}\n.section-invert .col-bg[data-v-14e697a9]{height:100%;min-height:60dvh;background-size:cover\n}\n.section-invert .quote[data-v-14e697a9]{text-transform:uppercase;font-size:.8rem\n}\n.section-invert .quote p[data-v-14e697a9]{letter-spacing:.75px\n}\n.section-invert .quote span[data-v-14e697a9]{font-weight:bold;color:#8A8A8A\n}\n.section-invert h3[data-v-14e697a9]{color:#eee;margin-bottom:3%\n}\n@media only screen and (min-width: 1024px){\n.section-invert h3[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert h3[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert h3[data-v-14e697a9]{font-size:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert h3[data-v-14e697a9]{font-size:2rem\n}\n}\n.section-invert h4[data-v-14e697a9]{color:#1D1D1E;z-index:1;font-size:4rem\n}\n.section-invert h6[data-v-14e697a9]{color:#1D1D1E;z-index:1;font-size:3rem\n}\n.section-invert h5[data-v-14e697a9]{color:#eee;padding:0\n}\n@media only screen and (min-width: 1024px){\n.section-invert h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-invert .content[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.section-invert .content[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.section-invert .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-invert .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:4rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert .subtitle[data-v-14e697a9]{width:100% !important\n}\n}\n.section-invert .subtitle p[data-v-14e697a9]{color:#8A8A8A\n}\n.section-invert .subtitle span[data-v-14e697a9]{color:#8A8A8A\n}\n.section-invert .subtitle .subtitle-list.subtitle-list-large p[data-v-14e697a9]{color:#eee;margin-top:0 !important;margin-bottom:0 !important\n}\n.section-invert .subtitle .subtitle-list:not(.subtitle-list-large) span[data-v-14e697a9]{color:#eee\n}\n.section-invert .subtitle .subtitle-list span[data-v-14e697a9]{font-size:1.25rem;display:inline-block\n}\n.section-invert .subtitle .subtitle-list>div[data-v-14e697a9]{margin-bottom:1rem;color:#eee\n}\n.section-invert .subtitle .subtitle-list>div>span[data-v-14e697a9]{font-size:1.5rem\n}\n.section-invert .col-bg[data-v-14e697a9]{width:100%\n}\n.section-white-list[data-v-14e697a9]{text-align:left\n}\n.section-white-list[data-v-14e697a9]:not(.h-auto){min-height:100dvh\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list[data-v-14e697a9]:not(.h-auto){min-height:60dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n.section-white-list h3[data-v-14e697a9]{line-height:1.2;font-size:3rem\n}\n@media only screen and (max-width: 575px){\n.section-white-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.section-white-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n.section-white-list h5[data-v-14e697a9]{font-size:2rem\n}\n@media only screen and (min-width: 1024px){\n.section-white-list h5[data-v-14e697a9]{padding:0 25rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list h5[data-v-14e697a9]{padding:0 10rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list h5[data-v-14e697a9]{padding:0rem\n}\n}\n.section-white-list .subtitle[data-v-14e697a9]{width:100%\n}\n@media only screen and (min-width: 1024px){\n.section-white-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n.section-white-list .subtitle p[data-v-14e697a9]{font-size:1.25rem\n}\n.section-white-list .col-bg[data-v-14e697a9]{height:100%;min-height:60dvh;background-size:cover\n}\n.section-white-list .quote[data-v-14e697a9]{text-transform:uppercase;font-size:.8rem\n}\n.section-white-list .quote p[data-v-14e697a9]{letter-spacing:.75px\n}\n.section-white-list .quote span[data-v-14e697a9]{font-weight:bold;color:#8A8A8A\n}\n.section-white-list h3[data-v-14e697a9]{color:#1D1D1E;margin-bottom:3%\n}\n@media only screen and (min-width: 1024px){\n.section-white-list h3[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list h3[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list h3[data-v-14e697a9]{font-size:1.75rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list h3[data-v-14e697a9]{font-size:1.75rem\n}\n}\n.section-white-list h5[data-v-14e697a9]{color:#3238C4;padding:0;margin-top:1rem\n}\n@media only screen and (min-width: 1024px){\n.section-white-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-white-list .content[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.section-white-list .content[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.section-white-list .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-white-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:4rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list .subtitle[data-v-14e697a9]{width:100% !important\n}\n}\n.section-white-list .subtitle p[data-v-14e697a9]{color:#8A8A8A\n}\n.section-white-list .subtitle span[data-v-14e697a9]{color:#8A8A8A\n}\n.section-white-list .subtitle .subtitle-list.subtitle-list-large p[data-v-14e697a9]{color:#1D1D1E;margin-top:0 !important;margin-bottom:0 !important\n}\n.section-white-list .subtitle .subtitle-list:not(.subtitle-list-large) span[data-v-14e697a9]{color:#eee\n}\n.section-white-list .subtitle .subtitle-list span[data-v-14e697a9]{font-size:1.25rem;display:inline-block\n}\n.section-white-list .subtitle .subtitle-list>div[data-v-14e697a9]{margin-bottom:1rem;color:#eee\n}\n.section-white-list .subtitle .subtitle-list>div>span[data-v-14e697a9]{font-size:1.5rem\n}\n.section-white-list .col-bg[data-v-14e697a9]{width:100%\n}\n.section-black-list[data-v-14e697a9]{text-align:left;background-color:#1D1D1E\n}\n.section-black-list[data-v-14e697a9]:not(.h-auto){min-height:100dvh\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list[data-v-14e697a9]:not(.h-auto){min-height:60dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n.section-black-list h3[data-v-14e697a9]{line-height:1.2;font-size:3rem\n}\n@media only screen and (max-width: 575px){\n.section-black-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.section-black-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n.section-black-list h5[data-v-14e697a9]{font-size:2rem\n}\n@media only screen and (min-width: 1024px){\n.section-black-list h5[data-v-14e697a9]{padding:0 25rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list h5[data-v-14e697a9]{padding:0 10rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list h5[data-v-14e697a9]{padding:0rem\n}\n}\n.section-black-list .subtitle[data-v-14e697a9]{width:100%\n}\n@media only screen and (min-width: 1024px){\n.section-black-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n.section-black-list .subtitle p[data-v-14e697a9]{font-size:1.25rem\n}\n.section-black-list .col-bg[data-v-14e697a9]{height:100%;min-height:60dvh;background-size:cover\n}\n.section-black-list .quote[data-v-14e697a9]{text-transform:uppercase;font-size:.8rem\n}\n.section-black-list .quote p[data-v-14e697a9]{letter-spacing:.75px\n}\n.section-black-list .quote span[data-v-14e697a9]{font-weight:bold;color:#8A8A8A\n}\n.section-black-list h3[data-v-14e697a9]{color:#eee\n}\n.section-black-list h4[data-v-14e697a9]{color:#1D1D1E;z-index:1;font-size:4rem\n}\n.section-black-list h5[data-v-14e697a9]{color:#eee;padding:0\n}\n@media only screen and (min-width: 1024px){\n.section-black-list h5[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list h5[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list h5[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-black-list .content[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.section-black-list .content[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.section-black-list .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-black-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:4rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list .subtitle .btn-hurts[data-v-14e697a9]{width:70% !important;margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list .subtitle[data-v-14e697a9]{width:100% !important\n}\n}\n.section-black-list .subtitle p[data-v-14e697a9]{color:#8A8A8A\n}\n.section-black-list .subtitle span[data-v-14e697a9]{color:#8A8A8A\n}\n.section-black-list .subtitle .subtitle-list.subtitle-list-large p[data-v-14e697a9]{color:#1D1D1E;margin-top:0 !important;margin-bottom:0 !important\n}\n.section-black-list .subtitle .subtitle-list:not(.subtitle-list-large) span[data-v-14e697a9]{color:#8A8A8A\n}\n.section-black-list .subtitle .subtitle-list span[data-v-14e697a9]{font-size:1.25rem;display:inline-block\n}\n.section-black-list .subtitle .subtitle-list>div[data-v-14e697a9]{margin-bottom:1rem;color:#eee\n}\n.section-black-list .subtitle .subtitle-list>div>span[data-v-14e697a9]{font-size:1.5rem\n}\n.section-black-list .col-bg[data-v-14e697a9]{width:100%\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nbody div#hubspot-messages-iframe-container.widget-align-right[data-v-14e697a9]{right:5rem !important\n}\n}\n@media only screen and (max-width: 575px){\nbody div#hubspot-messages-iframe-container.widget-align-right[data-v-14e697a9]{right:0rem !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nbody div#hubspot-messages-iframe-container[data-v-14e697a9]{bottom:100px !important\n}\n}\n@media only screen and (max-width: 575px){\nbody div#hubspot-messages-iframe-container[data-v-14e697a9]{bottom:100px !important\n}\n}\n@media only screen and (max-width: 575px){\n.reverse-sm[data-v-14e697a9]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.reverse-sm[data-v-14e697a9]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n.neu-card[data-v-14e697a9]{border-radius:23px;display:block\n}\n.neu-card[data-v-14e697a9]:not(.black){-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee\n}\n.neu-card.black[data-v-14e697a9]{-webkit-box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784)\n}\n@media only screen and (min-width: 1024px){\n.neu-card[data-v-14e697a9]{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card[data-v-14e697a9]{padding:0rem 5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card[data-v-14e697a9]{padding:7rem;width:100%;max-width:none\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card[data-v-14e697a9]{padding:5rem 3rem\n}\n}\n.neu-card-icon[data-v-14e697a9]{border-radius:23px;display:block\n}\n.neu-card-icon[data-v-14e697a9]:not(.black){-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee\n}\n.neu-card-icon.black[data-v-14e697a9]{-webkit-box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784)\n}\n@media only screen and (min-width: 1024px){\n.neu-card-icon[data-v-14e697a9]{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-icon[data-v-14e697a9]{padding:0rem 5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-icon[data-v-14e697a9]{padding:7rem;width:100%;max-width:none\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-icon[data-v-14e697a9]{padding:5rem 3rem\n}\n}\n.neu-card-price[data-v-14e697a9]{border-radius:23px;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n.neu-card-price[data-v-14e697a9]:not(.black){-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee\n}\n.neu-card-price.black[data-v-14e697a9]{-webkit-box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #000,10px 10px 35px rgba(13,39,80,0.160784)\n}\n@media only screen and (min-width: 1024px){\n.neu-card-price[data-v-14e697a9]{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-price[data-v-14e697a9]{padding:0rem 5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-price[data-v-14e697a9]{padding:7rem;width:100%;max-width:none\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-price[data-v-14e697a9]{padding:5rem 3rem\n}\n}\n[data-v-14e697a9].cert-icons{margin-left:auto !important\n}\n[data-v-14e697a9].cert-icons div{margin-top:auto;margin-bottom:auto;margin-right:5rem;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n[data-v-14e697a9].cert-icons div img{margin:auto;float:left;-o-object-fit:cover;object-fit:cover\n}\n[data-v-14e697a9].cert-icons div img.vertical{height:140px\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons div img.vertical{height:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons div img.vertical{height:70px\n}\n}\n[data-v-14e697a9].cert-icons div img:not(.vertical){width:140px\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons div img:not(.vertical){width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons div img:not(.vertical){width:70px\n}\n}\n[data-v-14e697a9].cert-icons-footer{margin-left:auto !important\n}\n[data-v-14e697a9].cert-icons-footer div{margin-top:auto;margin-bottom:auto;margin-right:5rem;display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons-footer div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons-footer div{margin-right:2rem;padding-top:1rem;padding-bottom:1rem\n}\n}\n[data-v-14e697a9].cert-icons-footer div img{margin:auto;float:left;-o-object-fit:cover;object-fit:cover\n}\n[data-v-14e697a9].cert-icons-footer div img.first-icon{width:130px;height:auto\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons-footer div img.first-icon{width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons-footer div img.first-icon{width:70px\n}\n}\n[data-v-14e697a9].cert-icons-footer div img.last-icon{width:150px;height:auto\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons-footer div img.last-icon{width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons-footer div img.last-icon{width:70px\n}\n}\n[data-v-14e697a9].cert-icons-footer div img.middle-icon{width:80px;height:auto\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons-footer div img.middle-icon{width:70px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons-footer div img.middle-icon{width:70px\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.my-0-manuel[data-v-14e697a9]{margin-top:0 !important;margin-bottom:0 !important\n}\n}\n@media only screen and (min-width: 1024px){\n.mb-xl-6[data-v-14e697a9]{margin-bottom:3rem !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.main-block-xs[data-v-14e697a9]{height:45vh\n}\n@supports (height: 100dvh){\n.main-block-xs[data-v-14e697a9]{height:45dvh\n}\n}\n}\n@media only screen and (max-width: 575px){\n.main-block-xs[data-v-14e697a9]{height:45vh\n}\n@supports (height: 100dvh){\n.main-block-xs[data-v-14e697a9]{height:45dvh\n}\n}\n}\n[data-v-14e697a9].cert-icons div{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons div{margin-top:auto;margin-bottom:auto;margin-right:1rem\n}\n}\n@media only screen and (min-width: 1024px){\n[data-v-14e697a9].cert-icons div{margin-top:auto;margin-bottom:auto\n}\n[data-v-14e697a9].cert-icons div:not(:last-child){margin-right:3rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-14e697a9].cert-icons div{margin-top:auto;margin-bottom:auto\n}\n[data-v-14e697a9].cert-icons div:not(:last-child){margin-right:1rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons div{margin-top:auto;margin-bottom:auto\n}\n[data-v-14e697a9].cert-icons div:not(:last-child){margin-right:5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons div{padding-top:1rem;padding-bottom:1rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons div{padding-top:1rem;padding-bottom:1rem\n}\n}\n[data-v-14e697a9].cert-icons div img{margin:auto;float:left;-o-object-fit:cover;object-fit:cover\n}\n@media only screen and (min-width: 1024px){\n[data-v-14e697a9].cert-icons div img.vertical{height:7rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-14e697a9].cert-icons div img.vertical{height:6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9].cert-icons div img.vertical{height:6rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons div img.vertical{height:6rem\n}\n}\n[data-v-14e697a9].cert-icons div img:not(.vertical){width:120px\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].cert-icons div img:not(.vertical){width:100px\n}\n}\n@media only screen and (min-width: 1024px){\n.plan-card-footer[data-v-14e697a9]{width:12rem;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-top:2px solid #cccbcb\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.plan-card-footer[data-v-14e697a9]{white-space:initial;width:auto;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-top:2px solid #cccbcb\n}\n}\n@media only screen and (max-width: 575px){\n.plan-card-footer[data-v-14e697a9]{white-space:initial;width:auto;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;border-top:2px solid #cccbcb\n}\n}\n@media screen and (min-width: 900px){\n.plan-card-footer[data-v-14e697a9]{margin-top:10%;margin-right:20%;position:absolute\n}\n}\n.landing-cnt[data-v-14e697a9]{min-height:100vh;color:#1D1D1E;text-align:left\n}\n@supports (height: 100dvh){\n.landing-cnt[data-v-14e697a9]{min-height:100dvh\n}\n}\n.landing-cnt.panel-cnt[data-v-14e697a9]{min-height:80vh\n}\n@supports (height: 100dvh){\n.landing-cnt.panel-cnt[data-v-14e697a9]{min-height:80dvh\n}\n}\n@media only screen and (min-width: 1024px){\n.landing-cnt[data-v-14e697a9]:not(.panel-cnt){padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.landing-cnt[data-v-14e697a9]:not(.panel-cnt){padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.landing-cnt[data-v-14e697a9]:not(.panel-cnt){padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt[data-v-14e697a9]:not(.panel-cnt){padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.landing-cnt[data-v-14e697a9]:not(.panel-cnt){padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt[data-v-14e697a9]:not(.panel-cnt){padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 1024px){\n.landing-cnt:not(.panel-cnt) .logged-ctn[data-v-14e697a9]{padding-top:100px\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt[data-v-14e697a9]{padding-left:0 !important;padding-right:0 !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt[data-v-14e697a9]{padding-left:0 !important;padding-right:0 !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .text-block-ctn[data-v-14e697a9]{min-height:50vh\n}\n@supports (height: 100dvh){\n.landing-cnt .text-block-ctn[data-v-14e697a9]{min-height:50dvh\n}\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt .text-block-ctn[data-v-14e697a9]{min-height:55vh\n}\n@supports (height: 100dvh){\n.landing-cnt .text-block-ctn[data-v-14e697a9]{min-height:55dvh\n}\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 1024px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:9rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 2000px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:11rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:2rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 1024px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:6rem\n}\n}\n@media only screen and (min-width: 1024px) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:6rem\n}\n}\n@media only screen and (min-width: 1024px) and (max-width: 575px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding:0\n}\n}\n@media only screen and (min-width: 1024px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{margin-top:auto;margin-bottom:auto\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 1024px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 2000px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (max-width: 575px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 575px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 1024px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 1024px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 2000px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 2000px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-width: 575px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-width: 575px){\n.landing-cnt .text-block-ctn .text-ctn[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n.landing-cnt h3[data-v-14e697a9]{color:#3238C4;font-size:1.25rem\n}\n@media only screen and (min-width: 1024px){\n.landing-cnt h3[data-v-14e697a9]{margin-top:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt h3[data-v-14e697a9]{font-size:1.25rem;margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.landing-cnt h3[data-v-14e697a9]{font-size:1.25rem;margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt h3[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt h3[data-v-14e697a9]{font-size:1.25rem\n}\n}\n.landing-cnt p[data-v-14e697a9]{margin-top:2rem;font-size:1.15rem;position:relative\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt p[data-v-14e697a9]{font-size:1rem;margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt p[data-v-14e697a9]{font-size:1rem;margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.landing-cnt p[data-v-14e697a9]{font-size:1rem;margin-top:1rem\n}\n}\n@media only screen and (max-height: 575px) and (orientation: landscape){\n.landing-cnt p[data-v-14e697a9]{font-size:.75rem\n}\n}\n.landing-cnt .bg-heart[data-v-14e697a9]{position:absolute;background-image:url(\"/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_BigHeart.svg\");-webkit-transform:translateZ(0);transform:translateZ(0);z-index:-1;opacity:100%\n}\n@media only screen and (min-width: 1024px){\n.landing-cnt .bg-heart[data-v-14e697a9]{height:100dvh;background-size:contain;background-position:top;background-repeat:no-repeat;width:100%;top:0;left:0;-webkit-transition:all .5s ease;transition:all .5s ease\n}\n}\n@media only screen and (max-height: 575px) and (orientation: landscape){\n.landing-cnt .bg-heart[data-v-14e697a9]{height:100dvh;background-size:contain;background-position:top;background-repeat:no-repeat;width:100%;top:0;left:0;-webkit-transition:all .5s ease;transition:all .5s ease\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .bg-heart[data-v-14e697a9]{background-position-y:center;background-size:contain;background-repeat:no-repeat\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-height: 640px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-height: 640px) and (orientation: portrait){\n.landing-cnt .bg-heart[data-v-14e697a9]{height:55dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .bg-heart[data-v-14e697a9]{background-position-x:calc(100% + 225px);height:50dvh;top:50dvh;width:100%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-width: 575px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-width: 575px){\n.landing-cnt .bg-heart[data-v-14e697a9]{background-position-x:calc(100% + 150px);height:55dvh;top:45dvh;width:100%\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt .bg-heart[data-v-14e697a9]{background-position-y:center;background-size:contain;background-repeat:no-repeat\n}\n}\n@media only screen and (max-width: 575px) and (max-height: 640px) and (orientation: portrait){\n.landing-cnt .bg-heart[data-v-14e697a9]{height:55dvh\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (max-width: 575px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .bg-heart[data-v-14e697a9]{background-position-x:calc(100% + 225px);height:50dvh;top:50dvh;width:100%\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 575px){\n.landing-cnt .bg-heart[data-v-14e697a9]{background-position-x:calc(100% + 150px);height:55dvh;top:45dvh;width:100%\n}\n}\n.landing-cnt .bg-image[data-v-14e697a9]{-webkit-animation:fade-in 2s ease-in;animation:fade-in 2s ease-in;position:absolute;background-image:-webkit-gradient(linear, left top, left bottom, from(#020024), color-stop(0%, #fff), color-stop(50%, rgba(141,194,204,0))),url(\"/static-appopensalud/img/bgs/opt/oceano.webp\");background-image:linear-gradient(180deg, #020024 0%, #fff 0%, rgba(141,194,204,0) 50%),url(\"/static-appopensalud/img/bgs/opt/oceano.webp\");opacity:70%\n}\n@media only screen and (min-width: 1024px){\n.landing-cnt .bg-image[data-v-14e697a9]{width:50vw;height:100vh;background-size:cover;right:0;background-position-x:right\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt .bg-image[data-v-14e697a9]{width:100%;background-size:cover;background-position:top;top:0;right:0\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (max-width: 575px) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .bg-image[data-v-14e697a9]{height:50vh\n}\n@supports (height: 100dvh){\n.landing-cnt .bg-image[data-v-14e697a9]{height:50dvh\n}\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 575px){\n.landing-cnt .bg-image[data-v-14e697a9]{height:45vh\n}\n@supports (height: 100dvh){\n.landing-cnt .bg-image[data-v-14e697a9]{height:45dvh\n}\n}\n}\n@media only screen and (max-width: 575px) and (max-height: 640px) and (orientation: portrait){\n.landing-cnt .bg-image[data-v-14e697a9]{height:45vh\n}\n@supports (height: 100dvh){\n.landing-cnt .bg-image[data-v-14e697a9]{height:45dvh\n}\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .bg-image[data-v-14e697a9]{width:100%;background-size:cover;background-position:top;top:0;right:0\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .bg-image[data-v-14e697a9]{height:50vh\n}\n@supports (height: 100dvh){\n.landing-cnt .bg-image[data-v-14e697a9]{height:50dvh\n}\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-width: 575px), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-width: 575px){\n.landing-cnt .bg-image[data-v-14e697a9]{height:45vh\n}\n@supports (height: 100dvh){\n.landing-cnt .bg-image[data-v-14e697a9]{height:45dvh\n}\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait) and (max-height: 640px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) and (max-height: 640px) and (orientation: portrait){\n.landing-cnt .bg-image[data-v-14e697a9]{height:45vh\n}\n@supports (height: 100dvh){\n.landing-cnt .bg-image[data-v-14e697a9]{height:45dvh\n}\n}\n}\n.landing-cnt h1[data-v-14e697a9]{line-height:1.2;font-size:42px\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt h1[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt h1[data-v-14e697a9]{font-size:2rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.landing-cnt h1[data-v-14e697a9]{font-size:2rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.landing-cnt h1[data-v-14e697a9]{font-size:2rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.landing-cnt h1[data-v-14e697a9]{font-size:2rem\n}\n}\n@media only screen and (max-height: 575px) and (orientation: landscape){\n.landing-cnt h1[data-v-14e697a9]{font-size:1.75rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .btn-cnt[data-v-14e697a9]{margin-top:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt .btn-cnt[data-v-14e697a9]{margin-top:0 !important\n}\n}\n.landing-cnt .btn-cnt button[data-v-14e697a9]{font-weight:bold\n}\n@media only screen and (max-width: 575px){\n.landing-cnt .btn-cnt button[data-v-14e697a9]{margin-top:0rem\n}\n}\n.landing-cnt .learn-more[data-v-14e697a9]{position:fixed;bottom:0;color:#3238C4;border-left:1px solid #3238C4;padding:0 0 2rem .5rem;cursor:pointer;font-size:.8rem;-webkit-transition-duration:.5s;transition-duration:.5s\n}\n@media only screen and (min-width: 1024px){\n.landing-cnt .learn-more[data-v-14e697a9]{left:44vw\n}\n}\n.landing-cnt .learn-more[data-v-14e697a9]:hover{font-size:1rem;-webkit-transition-duration:.5s;transition-duration:.5s\n}\n.landing-cnt .learn-more span[data-v-14e697a9]{-webkit-writing-mode:tb-rl;-ms-writing-mode:tb-rl;writing-mode:tb-rl;-webkit-transform:rotate(-180deg);transform:rotate(-180deg)\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.landing-cnt .learn-more[data-v-14e697a9]{left:7rem\n}\n}\n@media only screen and (max-width: 575px){\n.landing-cnt .learn-more[data-v-14e697a9]{display:none\n}\n}\n#integral-solutions .col-bg[data-v-14e697a9]{background-blend-mode:overlay;background-image:url(\"/static-appopensalud/img/bgs/opt/integral-solutions.webp\"),-webkit-gradient(linear, left top, left bottom, from(rgba(228,228,228,0.75)), to(rgba(228,228,228,0.5)));background-image:url(\"/static-appopensalud/img/bgs/opt/integral-solutions.webp\"),linear-gradient(180deg, rgba(228,228,228,0.75), rgba(228,228,228,0.5));background-position-y:center\n}\n@media only screen and (max-height: 575px) and (orientation: landscape){\n#psychological-attention[data-v-14e697a9]{padding:2rem 0\n}\n}\n#psychological-attention .col-bg[data-v-14e697a9]{background-image:url(\"/static-appopensalud/img/bgs/pattern1.jpg\")\n}\n#psychological-attention img[data-v-14e697a9]{display:block\n}\n@media only screen and (min-width: 1024px){\n#psychological-attention img[data-v-14e697a9]{display:inline-block;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%);position:absolute;width:65%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#psychological-attention img[data-v-14e697a9]{all:initial;width:40%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#psychological-attention img[data-v-14e697a9]{margin-top:2rem\n}\n}\n@media only screen and (max-width: 575px){\n#psychological-attention img[data-v-14e697a9]{margin-top:2rem\n}\n}\n@media only screen and (max-width: 575px){\n#psychological-attention img[data-v-14e697a9]{width:65%\n}\n}\n#psychological-attention .subtitle p[data-v-14e697a9]{color:#eee\n}\n@media only screen and (min-width: 1024px){\n#psychological-attention .subtitle p[data-v-14e697a9]{font-size:1.35rem\n}\n}\n#social-benefit .col-bg[data-v-14e697a9]{background-blend-mode:overlay;background-position-y:center;background-image:url(\"/static-appopensalud/img/bgs/texture.jpg\")\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n#social-benefit .content[data-v-14e697a9]{padding-top:7rem;padding-bottom:7rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#telemedicine-services[data-v-14e697a9]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n@media only screen and (max-width: 575px){\n#telemedicine-services[data-v-14e697a9]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n#telemedicine-services .col-bg[data-v-14e697a9]{background-blend-mode:overlay;background-image:url(\"/static-appopensalud/img/bgs/opt/using_oximeter.jpg\"),-webkit-gradient(linear, left top, left bottom, from(rgba(228,228,228,0.333333)), to(#e4e4e4));background-image:url(\"/static-appopensalud/img/bgs/opt/using_oximeter.jpg\"),linear-gradient(180deg, rgba(228,228,228,0.333333), #e4e4e4);background-position-y:center\n}\n#digital-health-platform .col-bg[data-v-14e697a9]{background-image:url(\"/static-appopensalud/img/bgs/custom_app_holding_hand_companies.png\")\n}\n@media only screen and (min-width: 1024px){\n#digital-health-platform .col-bg[data-v-14e697a9]{background-size:contain;background-repeat:no-repeat;background-position-x:center\n}\n}\n#wellness .col-bg[data-v-14e697a9]{background-image:url(\"/static-appopensalud/img/bgs/opt/wellness.jpg\"),-webkit-gradient(linear, right top, left top, from(rgba(228,228,228,0.733333)), to(transparent));background-image:url(\"/static-appopensalud/img/bgs/opt/wellness.jpg\"),linear-gradient(270deg, rgba(228,228,228,0.733333), transparent);background-position-y:center;background-blend-mode:overlay\n}\n#wellness-services .section[data-v-14e697a9]{min-height:initial\n}\n.subtitle-list span[data-v-14e697a9]{line-height:3rem;color:#eee\n}\n.section[data-v-14e697a9]{text-align:left\n}\n.section[data-v-14e697a9]:not(.h-auto){min-height:100dvh\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section[data-v-14e697a9]:not(.h-auto){min-height:60dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n.section h3[data-v-14e697a9]{line-height:1.2;font-size:3rem\n}\n@media only screen and (max-width: 575px){\n.section h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.section h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n.section h5[data-v-14e697a9]{font-size:2rem\n}\n@media only screen and (min-width: 1024px){\n.section h5[data-v-14e697a9]{padding:0 25rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section h5[data-v-14e697a9]{padding:0 10rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section h5[data-v-14e697a9]{padding:0rem\n}\n}\n.section .subtitle[data-v-14e697a9]{width:100%\n}\n@media only screen and (min-width: 1024px){\n.section .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.section .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n.section .subtitle p[data-v-14e697a9]{font-size:1.25rem\n}\n.section .col-bg[data-v-14e697a9]{height:100%;min-height:60dvh;background-size:cover\n}\n.section .quote[data-v-14e697a9]{text-transform:uppercase;font-size:.8rem\n}\n.section .quote p[data-v-14e697a9]{letter-spacing:.75px\n}\n.section .quote span[data-v-14e697a9]{font-weight:bold;color:#8A8A8A\n}\n@media only screen and (max-width: 575px){\n.section[data-v-14e697a9]{padding:0\n}\n}\n@media only screen and (min-width: 1024px){\n.section[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.section[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.section[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.section[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n.section .subtitle p[data-v-14e697a9]{color:#3238C4\n}\n.section .subtitle span[data-v-14e697a9]{font-size:1rem\n}\n.section button[data-v-14e697a9]{color:#3238C4;background-color:white;font-weight:bold\n}\n.section button[data-v-14e697a9]:not(:hover){border-color:white\n}\n.section .col-bg[data-v-14e697a9]{width:85%\n}\n@media only screen and (max-width: 575px){\n.section .col-bg[data-v-14e697a9]{width:100vw\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section .col-bg[data-v-14e697a9]{width:100vw\n}\n}\n@media only screen and (max-width: 575px){\n.section .col-bg[data-v-14e697a9]{margin-left:-2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-general-ctn[data-v-14e697a9]{margin-left:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-general-ctn[data-v-14e697a9]{padding-left:2rem;padding-right:2rem\n}\n}\n.neu-card-general-ctn>div[data-v-14e697a9]{cursor:pointer\n}\n@media only screen and (min-width: 1024px){\n.neu-card-general-ctn>div[data-v-14e697a9]:not(:last-child){margin-right:2rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-general-ctn>div[data-v-14e697a9]:not(:last-child){margin-right:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-general-ctn>div[data-v-14e697a9]:not(:last-child){margin-right:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-general-ctn>div[data-v-14e697a9]:not(:last-child){margin-right:2rem\n}\n}\n.neu-card-general[data-v-14e697a9]{background-color:#eee;-webkit-transition:all .5s ease;transition:all .5s ease;text-align:center;margin-top:auto;margin-bottom:auto\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-card-general[data-v-14e697a9]{padding:.5rem\n}\n}\n@media only screen and (max-width: 575px){\n.neu-card-general[data-v-14e697a9]{padding:1rem;margin-bottom:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-general[data-v-14e697a9]{padding:1rem;margin-bottom:2rem\n}\n}\n.neu-card-general[data-v-14e697a9]:hover{border:2px solid #3238C4\n}\n@media only screen and (max-width: 575px){\n.neu-card-general[data-v-14e697a9]{min-height:300px;margin-right:2%\n}\n}\n@media only screen and (min-width: 1024px){\n.neu-card-general[data-v-14e697a9]{min-height:300px;margin-right:2%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card-general[data-v-14e697a9]{min-height:300px\n}\n}\n.neu-card-general p[data-v-14e697a9]{color:#3238C4;font-weight:bold\n}\n.neu-card-general img[data-v-14e697a9]{width:20%\n}\n@media only screen and (min-width: 1024px){\n.logos-ctn[data-v-14e697a9]{margin-top:5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.logos-ctn[data-v-14e697a9]{margin-top:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.logos-ctn[data-v-14e697a9]{margin-top:5rem\n}\n}\n.logos-ctn .logos-row div[data-v-14e697a9]{padding:0;margin-top:auto;margin-bottom:auto\n}\n@media only screen and (max-width: 575px){\n.logos-ctn .logos-row div[data-v-14e697a9]{padding-bottom:3rem\n}\n}\n.logos-ctn .col[data-v-14e697a9]{margin:auto !important\n}\n.logos-ctn img[data-v-14e697a9]{width:55%\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.logos-ctn img[data-v-14e697a9]{width:70%\n}\n}\n@media only screen and (max-width: 575px){\n.logos-ctn img[data-v-14e697a9]{width:40%\n}\n}\n.logos-ctn h1[data-v-14e697a9]{color:#8A8A8A\n}\n@media only screen and (max-width: 575px){\n.reverse-sm[data-v-14e697a9]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.reverse-sm[data-v-14e697a9]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n@media only screen and (max-width: 575px){\n.carousel-container[data-v-14e697a9]{width:100% !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.carousel-container[data-v-14e697a9]{width:100% !important\n}\n}\n@media only screen and (min-width: 1024px){\n#security-data h3[data-v-14e697a9]{font-size:3rem !important\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n#security-data h3[data-v-14e697a9]{font-size:3rem !important\n}\n}\n@media only screen and (max-width: 575px){\n#security-data h3[data-v-14e697a9]{font-size:25px !important\n}\n}\n#security-data .col-bg[data-v-14e697a9]{background-blend-mode:overlay;background-image:url(\"/static-appopensalud/img/bgs/opt/privacity.jpg\")\n}\n@media only screen and (max-width: 575px){\n#security-data .col-bg[data-v-14e697a9]{display:none\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#security-data .col-bg[data-v-14e697a9]{display:none\n}\n}\n.neu-card[data-v-14e697a9]{background-color:#eee;-webkit-transition:all .5s ease;transition:all .5s ease;text-align:center\n}\n@media only screen and (max-width: 575px){\n.neu-card[data-v-14e697a9]{display:-webkit-inline-box !important;display:-ms-inline-flexbox !important;display:inline-flex !important;position:relative;padding:1rem;margin-bottom:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card[data-v-14e697a9]{display:-webkit-inline-box !important;display:-ms-inline-flexbox !important;display:inline-flex !important;position:relative;padding:1rem;margin-bottom:2rem\n}\n}\n.neu-card[data-v-14e697a9]:hover{border:2px solid #3238C4\n}\n@media only screen and (max-width: 575px){\n.neu-card[data-v-14e697a9]{min-height:300px;margin-right:2%\n}\n}\n@media only screen and (min-width: 1024px){\n.neu-card[data-v-14e697a9]{min-height:300px;margin-right:2%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-card[data-v-14e697a9]{min-height:300px\n}\n}\n.section-black-list .subtitle[data-v-14e697a9]{margin-top:0rem !important\n}\n@media only screen and (max-width: 575px){\n.section-black-list[data-v-14e697a9]{width:100%\n}\n.section-black-list span[data-v-14e697a9]{line-height:2rem\n}\n}\n@media only screen and (min-width: 1024px){\n#service-blocks h3[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n#service-blocks h3[data-v-14e697a9]{font-size:2rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n#service-blocks h3[data-v-14e697a9]{font-size:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#service-blocks h3[data-v-14e697a9]{font-size:2rem\n}\n}\n@media only screen and (max-width: 575px){\n#service-blocks h3[data-v-14e697a9]{font-size:2rem\n}\n}\n#service-blocks h3.main-title[data-v-14e697a9]{color:#3238C4\n}\n#service-blocks h3[data-v-14e697a9]:not(.main-title){font-size:1.75rem\n}\n#service-blocks h5[data-v-14e697a9]{font-size:1.25rem;padding:0\n}\n@media only screen and (min-width: 1024px){\n#service-blocks .col[data-v-14e697a9],#service-blocks [class*=\"col-\"][data-v-14e697a9]{padding:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#service-blocks .col[data-v-14e697a9],#service-blocks [class*=\"col-\"][data-v-14e697a9]{padding:0;padding-top:2rem;padding-bottom:2rem\n}\n#service-blocks .col[data-v-14e697a9]:nth-child(odd),#service-blocks [class*=\"col-\"][data-v-14e697a9]:nth-child(odd){padding-right:2rem\n}\n#service-blocks .col[data-v-14e697a9]:nth-child(even),#service-blocks [class*=\"col-\"][data-v-14e697a9]:nth-child(even){padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px){\n#service-blocks .col[data-v-14e697a9],#service-blocks [class*=\"col-\"][data-v-14e697a9]{padding:1rem 0\n}\n}\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);text-align:center;margin:auto;border-radius:23px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n@media only screen and (min-width: 1024px){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{padding:3rem 4rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{padding:3rem 1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{padding:2rem 2.5rem\n}\n}\n@media only screen and (max-width: 575px){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{padding:2rem 1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{margin:2rem 1rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{margin:2rem 1rem\n}\n}\n@media only screen and (max-height: 575px) and (orientation: landscape){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{margin:2rem 1rem\n}\n}\n@media only screen and (min-width: 1024px){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{min-height:300px\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{min-height:300px\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{min-height:300px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#service-blocks .col .box[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box[data-v-14e697a9]{min-height:350px\n}\n}\n#service-blocks .col .box.bg-heart-sm[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box.bg-heart-sm[data-v-14e697a9]{background-image:url(/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_BigHeart.svg);background-size:cover;background-position-x:13rem;background-repeat:no-repeat\n}\n@media only screen and (min-width: 1024px){\n#service-blocks .col .box.bg-heart-sm[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box.bg-heart-sm[data-v-14e697a9]{background-position-x:13rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#service-blocks .col .box.bg-heart-sm[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box.bg-heart-sm[data-v-14e697a9]{background-position-x:initial;background-position-y:initial\n}\n}\n@media only screen and (max-width: 575px){\n#service-blocks .col .box.bg-heart-sm[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box.bg-heart-sm[data-v-14e697a9]{background-position-x:5rem;background-position-y:initial\n}\n}\n#service-blocks .col .box.bg-heart-big[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box.bg-heart-big[data-v-14e697a9]{background-image:url(/static-appopensalud/img/icons/morillas-svg-icons/primary/NEU_BigHeart.svg);background-size:cover;background-repeat:no-repeat\n}\n@media only screen and (min-width: 1024px){\n#service-blocks .col .box.bg-heart-big[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box.bg-heart-big[data-v-14e697a9]{background-position-x:15rem;background-position-y:-5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n#service-blocks .col .box.bg-heart-big[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box.bg-heart-big[data-v-14e697a9]{background-position-x:initial;background-position-y:initial\n}\n}\n@media only screen and (max-width: 575px){\n#service-blocks .col .box.bg-heart-big[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box.bg-heart-big[data-v-14e697a9]{background-position-x:-5rem;background-position-y:initial\n}\n}\n#service-blocks .col .box p[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box p[data-v-14e697a9]{margin-bottom:0\n}\n@media only screen and (max-width: 575px){\n#service-blocks .col .box p[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box p[data-v-14e697a9]{margin-top:.5rem\n}\n}\n#service-blocks .col img[data-v-14e697a9],#service-blocks [class*=\"col-\"] img[data-v-14e697a9]{width:36px\n}\n#service-blocks .col .box-title[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box-title[data-v-14e697a9]{font-weight:bold;display:block;color:#3238C4\n}\n@media only screen and (min-width: 1024px){\n#service-blocks .col .box-title[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box-title[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n#service-blocks .col .box-title[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box-title[data-v-14e697a9]{font-size:1.25rem\n}\n}\n@media only screen and (max-width: 575px){\n#service-blocks .col .box-title[data-v-14e697a9],#service-blocks [class*=\"col-\"] .box-title[data-v-14e697a9]{font-size:1.25rem\n}\n}\n[data-v-14e697a9].carousel-container{margin-top:-2rem !important\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9].carousel-3d-container{margin-top:-2rem\n}\n}\n#big-companies h5[data-v-14e697a9]{color:#3238C4\n}\na.nav-link[data-v-14e697a9]{color:#3238C4 !important\n}\n.navbar[data-v-14e697a9]{z-index:1000;width:100%;-webkit-box-pack:justify !important;-ms-flex-pack:justify !important;justify-content:space-between !important\n}\n@media only screen and (min-width: 1024px){\n.navbar[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.navbar[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.navbar[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.navbar[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.navbar[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.navbar[data-v-14e697a9]{padding-top:1rem\n}\n}\n@media only screen and (min-width: 1024px){\n.navbar .nav-item.nav-lang[data-v-14e697a9]{margin-right:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar ul.navbar-nav[data-v-14e697a9]:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);display:contents\n}\n.navbar .nav-item[data-v-14e697a9]{font-size:.875rem\n}\n.navbar .nav-item button[data-v-14e697a9]{border:0px;background-color:transparent;margin:0;font-weight:bold;font-size:.875rem;padding:0\n}\n}\n@media only screen and (max-width: 575px){\n.navbar ul.navbar-nav[data-v-14e697a9]:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);display:contents\n}\n.navbar .nav-item[data-v-14e697a9]{font-size:.875rem\n}\n.navbar .nav-item button[data-v-14e697a9]{border:0px;background-color:transparent;margin:0;font-weight:bold;font-size:.875rem;padding:0\n}\n}\n@media only screen and (max-height: 575px) and (orientation: landscape){\n.navbar ul.navbar-nav[data-v-14e697a9]:not(.outside-collapse){-webkit-transition:all .5s ease;transition:all .5s ease;background-color:#eee;border-radius:23px;-webkit-box-shadow:14px 14px 25px rgba(13,39,80,0.160784);box-shadow:14px 14px 25px rgba(13,39,80,0.160784);display:contents\n}\n.navbar .nav-item[data-v-14e697a9]{font-size:.875rem\n}\n.navbar .nav-item button[data-v-14e697a9]{border:0px;background-color:transparent;margin:0;font-weight:bold;font-size:.875rem;padding:0\n}\n}\n.navbar-brand-img[data-v-14e697a9]{width:175px\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.navbar-brand-img[data-v-14e697a9]{width:175px\n}\n}\n@media only screen and (max-width: 575px){\n.navbar-brand-img[data-v-14e697a9]{width:140px !important\n}\n}\n@media only screen and (min-width: 1024px){\n.ctm-container[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.ctm-container[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.ctm-container[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.ctm-container[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.ctm-container[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.ctm-container[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n.section-invert[data-v-14e697a9]{text-align:left;background-color:#1D1D1E\n}\n.section-invert[data-v-14e697a9]:not(.h-auto){min-height:100dvh\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert[data-v-14e697a9]:not(.h-auto){min-height:60dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n.section-invert h3[data-v-14e697a9]{line-height:1.2;font-size:3rem\n}\n@media only screen and (max-width: 575px){\n.section-invert h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.section-invert h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n.section-invert h5[data-v-14e697a9]{font-size:2rem\n}\n@media only screen and (min-width: 1024px){\n.section-invert h5[data-v-14e697a9]{padding:0 25rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert h5[data-v-14e697a9]{padding:0 10rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert h5[data-v-14e697a9]{padding:0rem\n}\n}\n.section-invert .subtitle[data-v-14e697a9]{width:100%\n}\n@media only screen and (min-width: 1024px){\n.section-invert .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n.section-invert .subtitle p[data-v-14e697a9]{font-size:1.25rem\n}\n.section-invert .col-bg[data-v-14e697a9]{height:100%;min-height:60dvh;background-size:cover\n}\n.section-invert .quote[data-v-14e697a9]{text-transform:uppercase;font-size:.8rem\n}\n.section-invert .quote p[data-v-14e697a9]{letter-spacing:.75px\n}\n.section-invert .quote span[data-v-14e697a9]{font-weight:bold;color:#8A8A8A\n}\n.section-invert h3[data-v-14e697a9]{color:#eee;margin-bottom:3%\n}\n@media only screen and (min-width: 1024px){\n.section-invert h3[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert h3[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert h3[data-v-14e697a9]{font-size:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert h3[data-v-14e697a9]{font-size:2rem\n}\n}\n.section-invert h4[data-v-14e697a9]{color:#1D1D1E;z-index:1;font-size:4rem\n}\n.section-invert h6[data-v-14e697a9]{color:#1D1D1E;z-index:1;font-size:3rem\n}\n.section-invert h5[data-v-14e697a9]{color:#eee;padding:0\n}\n@media only screen and (min-width: 1024px){\n.section-invert h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-invert .content[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.section-invert .content[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-invert .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.section-invert .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-invert .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-invert .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:4rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-invert .subtitle[data-v-14e697a9]{width:100% !important\n}\n}\n.section-invert .subtitle p[data-v-14e697a9]{color:#8A8A8A\n}\n.section-invert .subtitle span[data-v-14e697a9]{color:#8A8A8A\n}\n.section-invert .subtitle .subtitle-list.subtitle-list-large p[data-v-14e697a9]{color:#eee;margin-top:0 !important;margin-bottom:0 !important\n}\n.section-invert .subtitle .subtitle-list:not(.subtitle-list-large) span[data-v-14e697a9]{color:#eee\n}\n.section-invert .subtitle .subtitle-list span[data-v-14e697a9]{font-size:1.25rem;display:inline-block\n}\n.section-invert .subtitle .subtitle-list>div[data-v-14e697a9]{margin-bottom:1rem;color:#eee\n}\n.section-invert .subtitle .subtitle-list>div>span[data-v-14e697a9]{font-size:1.5rem\n}\n.section-invert .col-bg[data-v-14e697a9]{width:100%\n}\n.section-white-list[data-v-14e697a9]{text-align:left\n}\n.section-white-list[data-v-14e697a9]:not(.h-auto){min-height:100dvh\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list[data-v-14e697a9]:not(.h-auto){min-height:60dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n.section-white-list h3[data-v-14e697a9]{line-height:1.2;font-size:3rem\n}\n@media only screen and (max-width: 575px){\n.section-white-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.section-white-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n.section-white-list h5[data-v-14e697a9]{font-size:2rem\n}\n@media only screen and (min-width: 1024px){\n.section-white-list h5[data-v-14e697a9]{padding:0 25rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list h5[data-v-14e697a9]{padding:0 10rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list h5[data-v-14e697a9]{padding:0rem\n}\n}\n.section-white-list .subtitle[data-v-14e697a9]{width:100%\n}\n@media only screen and (min-width: 1024px){\n.section-white-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n.section-white-list .subtitle p[data-v-14e697a9]{font-size:1.25rem\n}\n.section-white-list .col-bg[data-v-14e697a9]{height:100%;min-height:60dvh;background-size:cover\n}\n.section-white-list .quote[data-v-14e697a9]{text-transform:uppercase;font-size:.8rem\n}\n.section-white-list .quote p[data-v-14e697a9]{letter-spacing:.75px\n}\n.section-white-list .quote span[data-v-14e697a9]{font-weight:bold;color:#8A8A8A\n}\n.section-white-list h3[data-v-14e697a9]{color:#1D1D1E;margin-bottom:3%\n}\n@media only screen and (min-width: 1024px){\n.section-white-list h3[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list h3[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list h3[data-v-14e697a9]{font-size:1.75rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list h3[data-v-14e697a9]{font-size:1.75rem\n}\n}\n.section-white-list h5[data-v-14e697a9]{color:#3238C4;padding:0;margin-top:1rem\n}\n@media only screen and (min-width: 1024px){\n.section-white-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-white-list .content[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.section-white-list .content[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-white-list .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.section-white-list .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-white-list .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-white-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:4rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-white-list .subtitle[data-v-14e697a9]{width:100% !important\n}\n}\n.section-white-list .subtitle p[data-v-14e697a9]{color:#8A8A8A\n}\n.section-white-list .subtitle span[data-v-14e697a9]{color:#8A8A8A\n}\n.section-white-list .subtitle .subtitle-list.subtitle-list-large p[data-v-14e697a9]{color:#1D1D1E;margin-top:0 !important;margin-bottom:0 !important\n}\n.section-white-list .subtitle .subtitle-list:not(.subtitle-list-large) span[data-v-14e697a9]{color:#eee\n}\n.section-white-list .subtitle .subtitle-list span[data-v-14e697a9]{font-size:1.25rem;display:inline-block\n}\n.section-white-list .subtitle .subtitle-list>div[data-v-14e697a9]{margin-bottom:1rem;color:#eee\n}\n.section-white-list .subtitle .subtitle-list>div>span[data-v-14e697a9]{font-size:1.5rem\n}\n.section-white-list .col-bg[data-v-14e697a9]{width:100%\n}\n.section-black-list[data-v-14e697a9]{text-align:left;background-color:#1D1D1E\n}\n.section-black-list[data-v-14e697a9]:not(.h-auto){min-height:100dvh\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list[data-v-14e697a9]:not(.h-auto){min-height:60dvh\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:5rem\n}\n}\n.section-black-list h3[data-v-14e697a9]{line-height:1.2;font-size:3rem\n}\n@media only screen and (max-width: 575px){\n.section-black-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1440px) and (max-height: 721px) and (orientation: landscape){\n.section-black-list h3[data-v-14e697a9]{font-size:1.5rem\n}\n}\n.section-black-list h5[data-v-14e697a9]{font-size:2rem\n}\n@media only screen and (min-width: 1024px){\n.section-black-list h5[data-v-14e697a9]{padding:0 25rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list h5[data-v-14e697a9]{padding:0 10rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list h5[data-v-14e697a9]{padding:0rem\n}\n}\n.section-black-list .subtitle[data-v-14e697a9]{width:100%\n}\n@media only screen and (min-width: 1024px){\n.section-black-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list .subtitle[data-v-14e697a9]{margin-top:1rem\n}\n}\n.section-black-list .subtitle p[data-v-14e697a9]{font-size:1.25rem\n}\n.section-black-list .col-bg[data-v-14e697a9]{height:100%;min-height:60dvh;background-size:cover\n}\n.section-black-list .quote[data-v-14e697a9]{text-transform:uppercase;font-size:.8rem\n}\n.section-black-list .quote p[data-v-14e697a9]{letter-spacing:.75px\n}\n.section-black-list .quote span[data-v-14e697a9]{font-weight:bold;color:#8A8A8A\n}\n.section-black-list h3[data-v-14e697a9]{color:#eee\n}\n.section-black-list h4[data-v-14e697a9]{color:#1D1D1E;z-index:1;font-size:4rem\n}\n.section-black-list h5[data-v-14e697a9]{color:#eee;padding:0\n}\n@media only screen and (min-width: 1024px){\n.section-black-list h5[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list h5[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list h5[data-v-14e697a9]{font-size:3rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list h5[data-v-14e697a9]{font-size:1.5rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-black-list .content[data-v-14e697a9]{padding-right:9rem;padding-left:9rem\n}\n}\n@media only screen and (min-width: 2000px){\n.section-black-list .content[data-v-14e697a9]{padding-right:11rem;padding-left:11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.section-black-list .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media (min-width: 768px) and (max-width: 1199.98px) and (orientation: landscape){\n.section-black-list .content[data-v-14e697a9]{padding-right:6rem;padding-left:6rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list .content[data-v-14e697a9]{padding-right:2rem;padding-left:2rem\n}\n}\n@media only screen and (min-width: 1024px){\n.section-black-list .content[data-v-14e697a9]{padding-top:4rem;padding-bottom:4rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list .subtitle .btn-hurts[data-v-14e697a9]{width:70% !important;margin-top:1rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.section-black-list .subtitle[data-v-14e697a9]{width:100% !important\n}\n}\n.section-black-list .subtitle p[data-v-14e697a9]{color:#8A8A8A\n}\n.section-black-list .subtitle span[data-v-14e697a9]{color:#8A8A8A\n}\n.section-black-list .subtitle .subtitle-list.subtitle-list-large p[data-v-14e697a9]{color:#1D1D1E;margin-top:0 !important;margin-bottom:0 !important\n}\n.section-black-list .subtitle .subtitle-list:not(.subtitle-list-large) span[data-v-14e697a9]{color:#8A8A8A\n}\n.section-black-list .subtitle .subtitle-list span[data-v-14e697a9]{font-size:1.25rem;display:inline-block\n}\n.section-black-list .subtitle .subtitle-list>div[data-v-14e697a9]{margin-bottom:1rem;color:#eee\n}\n.section-black-list .subtitle .subtitle-list>div>span[data-v-14e697a9]{font-size:1.5rem\n}\n.section-black-list .col-bg[data-v-14e697a9]{width:100%\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nbody div#hubspot-messages-iframe-container.widget-align-right[data-v-14e697a9]{right:5rem !important\n}\n}\n@media only screen and (max-width: 575px){\nbody div#hubspot-messages-iframe-container.widget-align-right[data-v-14e697a9]{right:0rem !important\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\nbody div#hubspot-messages-iframe-container[data-v-14e697a9]{bottom:100px !important\n}\n}\n@media only screen and (max-width: 575px){\nbody div#hubspot-messages-iframe-container[data-v-14e697a9]{bottom:100px !important\n}\n}\n@media only screen and (max-width: 575px){\n.reverse-sm[data-v-14e697a9]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.reverse-sm[data-v-14e697a9]{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9] .neu-card-general-ctn{margin-left:1rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9] .neu-card-general-ctn{padding-left:2rem;padding-right:2rem\n}\n}\n[data-v-14e697a9] .neu-card-general-ctn>div{cursor:pointer\n}\n@media only screen and (min-width: 1024px){\n[data-v-14e697a9] .neu-card-general-ctn>div:not(:last-child){margin-right:2rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-14e697a9] .neu-card-general-ctn>div:not(:last-child){margin-right:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9] .neu-card-general-ctn>div:not(:last-child){margin-right:2rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9] .neu-card-general-ctn>div:not(:last-child){margin-right:2rem\n}\n}\n[data-v-14e697a9] .neu-card-general{background-color:#eee;-webkit-transition:all .5s ease;transition:all .5s ease;text-align:center;margin-top:auto;margin-bottom:auto\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n[data-v-14e697a9] .neu-card-general{padding:.5rem\n}\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9] .neu-card-general{padding:1rem;margin-bottom:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9] .neu-card-general{padding:1rem;margin-bottom:2rem\n}\n}\n[data-v-14e697a9] .neu-card-general:hover{border:2px solid #3238C4\n}\n@media only screen and (max-width: 575px){\n[data-v-14e697a9] .neu-card-general{min-height:300px;margin-right:2%\n}\n}\n@media only screen and (min-width: 1024px){\n[data-v-14e697a9] .neu-card-general{min-height:300px;margin-right:2%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n[data-v-14e697a9] .neu-card-general{min-height:300px\n}\n}\n[data-v-14e697a9] .neu-card-general p{color:#3238C4;font-weight:bold\n}\n[data-v-14e697a9] .neu-card-general img{width:20%\n}\n.navbar-mobile[data-v-14e697a9]{padding-left:0rem !important\n}\n.btn-mobile[data-v-14e697a9]{background-color:white !important;width:4.5rem;font-size:0.8rem  !important;padding-left:0rem !important\n}\n.flex-mobile-lang[data-v-14e697a9]{display:-webkit-inline-box !important;display:-ms-inline-flexbox !important;display:inline-flex !important\n}\n@media only screen and (min-width: 1024px){\n.desktop-fix[data-v-14e697a9]{padding-left:20rem;padding-right:20rem;padding-top:3rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.desktop-fix[data-v-14e697a9]{padding-left:0rem;padding-right:0rem\n}\n}\n@media only screen and (max-width: 575px){\n.desktop-fix[data-v-14e697a9]{padding-top:0rem\n}\n}\n.desktop-fix-subtitle[data-v-14e697a9]{padding-top:1rem !important\n}\n@media only screen and (min-width: 1024px){\n.desktop-fix-subtitle[data-v-14e697a9]{padding-left:20rem;padding-right:20rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.desktop-fix-subtitle[data-v-14e697a9]{padding-left:0rem;padding-right:0rem\n}\n}\n@media only screen and (max-width: 575px){\n.desktop-fix-subtitle[data-v-14e697a9]{padding-left:0rem;padding-right:0rem\n}\n}\n.column_wrapper[data-v-14e697a9]{-webkit-column-count:3;-moz-column-count:3;column-count:3\n}\n.v-dialog--active .v-card__title[data-v-14e697a9]{color:#3238C4;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;word-break:break-word\n}\n.v-dialog__content .v-dialog--active .v-card__text ul li[data-v-14e697a9]{margin-top:5px\n}\n@media (max-width: 1268px){\n#discounts>div.content.my-auto.col-md-12.col-lg-6>div>div>div>p[data-v-14e697a9]{font-size:1rem\n}\n}\n@media (max-width: 960px){\n.v-dialog__content .v-dialog--active[data-v-14e697a9]{width:85vw\n}\n.column_wrapper[data-v-14e697a9]{-webkit-column-count:1;-moz-column-count:1;column-count:1\n}\n#discounts .subtitle[data-v-14e697a9]{width:100%\n}\n}\n@media (max-width: 960px) and (orientation: landscape){\n.column_wrapper[data-v-14e697a9]{-webkit-column-count:3;-moz-column-count:3;column-count:3\n}\n}\n@media only screen and (min-width: 1024px){\n.section-black-list h3[data-v-14e697a9]{font-size:2.5rem\n}\n}\n@media only screen and (max-width: 575px){\n.section-black-list .subtitle .subtitle-list>div[data-v-14e697a9]{margin-bottom:1rem\n}\n[data-v-14e697a9] .mobile{padding-top:0rem !important\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 3770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "landing-cnt row" }, [
        _c("div", { staticClass: "bg-heart" }),
        _vm._v(" "),
        _c("div", { staticClass: "bg-image" }),
        _vm._v(" "),
        _c("div", {
          staticClass: "col-12 d-landscape-none d-xl-none d-flex main-block-xs"
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "text-block-ctn col-desktop-6 col-landscape-6 col-xl-6 col-12 d-flex my-auto pt-4 pt-md-0"
          },
          [
            _c("div", { staticClass: "text-ctn my-auto" }, [
              _c("h1", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("os360-empresas.main-block.title"))
                }
              }),
              _vm._v(" "),
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("os360-empresas.main-block.subtitle")))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "d-mobile-rotated-none" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("os360-empresas.main-block.paragraph")) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-cnt mt-0 mt-mobile-rotated-4 mt-xl-5" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "mr-2 mr-md-4",
                      attrs: { pseudoShadow: "" },
                      on: { click: _vm.goToContactForm }
                    },
                    [_vm._v("+ Info\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      attrs: {
                        white: "",
                        pseudoShadow: "",
                        textColor: _vm.BLUE_COLOUR
                      },
                      on: { click: _vm.goTo360SignIn }
                    },
                    [_vm._v("\n              " + _vm._s(_vm.$t("log-in")))]
                  )
                ],
                1
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "section py-5", attrs: { id: "service-blocks" } },
        [
          _c(
            "b-row",
            {
              staticClass: "neu-cards-ctn m-auto text-center",
              attrs: { cols: "1", "cols-sm": "2", "cols-xl": "3" }
            },
            [
              _c("b-col", { staticClass: "my-auto" }, [
                _c("div", { staticClass: "box bg-heart-sm" }, [
                  _c("div", { staticClass: "my-auto" }, [
                    _c("h3", { staticClass: "main-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("os360-empresas.blocks.title")) + " "
                      ),
                      _c("br"),
                      _vm._v("opensalud360")
                    ]),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("h5", { staticClass: "d-block" }, [
                      _vm._v(
                        _vm._s(_vm.$t("os360-empresas.blocks.what-do-you-need"))
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.blocks, function(block) {
                return _c("b-col", { key: block.id, staticClass: "my-auto" }, [
                  _c("div", { staticClass: "box my-auto" }, [
                    _c(
                      "div",
                      { staticClass: "my-auto" },
                      [
                        _c("base-icon", {
                          staticClass: "d-block",
                          attrs: {
                            blue: "",
                            src: block.img,
                            alt: block.title,
                            size: "lg"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "box-title mt-3" }, [
                          _vm._v(_vm._s(block.title))
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(block.description))]),
                        _vm._v(" "),
                        _vm.inMx &&
                        block.title ===
                          _vm.$t("os360-empresas.blocks.opensaludpass.title")
                          ? _c("b-badge", { staticClass: "mt-4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "os360-empresas.blocks.opensaludpass.soon"
                                  )
                                )
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "my-auto",
                  attrs: { cols: "12", sm: "6", xl: "8" }
                },
                [
                  _c("div", { staticClass: "box bg-heart-big" }, [
                    _c(
                      "div",
                      { staticClass: "my-auto" },
                      [
                        _c("h3", { staticClass: "d-block" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("os360-empresas.blocks.more-info-question")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "base-button",
                          {
                            staticClass: "mt-2 mt-md-4",
                            attrs: { white: "", shadow: "" },
                            on: { click: _vm.goToContactForm }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "os360-empresas.big-companies.request-info"
                                  )
                                )
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.inMx
        ? _c(
            "b-row",
            {
              staticClass: "section-black-list",
              attrs: { id: "social-benefit" }
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "d-none d-xl-block",
                  attrs: { md: "12", xl: "6" }
                },
                [_c("div", { staticClass: "col-bg ml-lg-auto" })]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "content my-auto mx-auto",
                  attrs: { md: "12", xl: "6" }
                },
                [
                  _c("h3", [
                    _vm._v(
                      _vm._s(_vm.$t("os360-empresas.social-benefit.subtitle"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "subtitle pt-4" }, [
                    _c(
                      "div",
                      { staticClass: "subtitle-list subtitle-list-large" },
                      _vm._l([1, 2, 3, 4, 5, 6], function(i) {
                        return _c(
                          "b-row",
                          { key: i },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "tick-mobile",
                                attrs: { cols: "1" }
                              },
                              [
                                _c(
                                  "p",
                                  [
                                    _c("base-icon", {
                                      attrs: {
                                        src:
                                          "/static-appopensalud/img/icons/360/social-benefit-" +
                                          i +
                                          ".svg",
                                        width: "30",
                                        height: "30"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "my-auto",
                                attrs: {
                                  cols: "10",
                                  offset: "1",
                                  "offset-md": "0"
                                }
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t(
                                          "os360-empresas.social-benefit.list." +
                                            i
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticStyle: { color: "white" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "os360-empresas.social-benefit.security-description"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-row", { staticClass: "cert-icons mt-3 mt-md-5" }, [
                    _c(
                      "div",
                      { staticClass: "d-inline-block" },
                      [_c("ISO27001Logo")],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-inline-block" }, [
                      _c("img", {
                        staticClass: "vertical",
                        attrs: {
                          src:
                            "/static-appopensalud/img/icons/morillas-svg-icons/Logo/gdpr.webp"
                        }
                      })
                    ])
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "section mx-auto py-5", attrs: { id: "big-companies" } },
        [
          _c(
            "div",
            { staticClass: "my-auto text-center" },
            [
              _c("b-col", { attrs: { cols: "12" } }, [
                _c("h5", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("os360-empresas.companies")) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("h6", {
                  staticClass: "desktop-fix-subtitle",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("os360-empresas.companies2"))
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "logos-ctn col-12", attrs: { cols: "12" } },
                _vm._l(_vm.groupsOfLogos, function(groupOfLogos) {
                  return _c(
                    "b-row",
                    {
                      key: _vm.groupsOfLogos.indexOf(groupOfLogos),
                      staticClass: "logos-row mt-0 mt-sm-5"
                    },
                    _vm._l(groupOfLogos, function(logo) {
                      return _c(
                        "b-col",
                        {
                          key: logo.companyName,
                          attrs: {
                            cols: "12",
                            sm: "2",
                            "offset-sm":
                              groupOfLogos.indexOf(logo) == 0 ? 1 : null,
                            "offset-md":
                              groupOfLogos.indexOf(logo) == 0 ? 1 : null,
                            md: "2"
                          }
                        },
                        [
                          _c("img", {
                            style: {
                              width:
                                logo.width &&
                                !_vm.$uiHelpers.isMobile &&
                                !_vm.$uiHelpers.isTablet
                            },
                            attrs: { src: logo.logo, alt: logo.companyName }
                          })
                        ]
                      )
                    }),
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          staticClass: "section-invert",
          attrs: { id: "psychological-attention" }
        },
        [
          _c(
            "b-col",
            {
              staticClass: "content my-auto mx-auto",
              attrs: { md: "12", xl: "6" }
            },
            [
              _c("h3", [
                _vm._v(
                  _vm._s(_vm.$t("os360-empresas.psychological-attention.title"))
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "subtitle" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "pr-lg-5 pr-sm-0",
                          attrs: { sm: "12", lg: "12" }
                        },
                        [
                          _c("div", [
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "os360-empresas.psychological-attention.subtitle"
                                  )
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "os360-empresas.psychological-attention.text"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t(
                                  "os360-empresas.psychological-attention.subtitle-2"
                                )
                              )
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-col", { attrs: { sm: "12", lg: "12" } }, [
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "os360-empresas.psychological-attention.title-2"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t(
                                "os360-empresas.psychological-attention.text-2"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "d-block d-desktop-none d-xl-none",
                          attrs: {
                            src:
                              "/static-appopensalud/img/logos/logo-menttum-grande-blanco.png",
                            alt: "Menttum"
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "base-button",
                        {
                          staticClass: "mt-5",
                          attrs: { white: "" },
                          on: { click: _vm.goToContactForm }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("os360-empresas.more-information-btn")
                              )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "d-none d-desktop-block d-xl-block",
              attrs: { md: "12", xl: "6" }
            },
            [
              _c("img", {
                staticClass: "m-auto justify-content-center align-items-center",
                attrs: {
                  src: "/static-appopensalud/img/logos/logo-menttum-grande.png",
                  alt: "Menttum"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-bg ml-xl-auto" })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("companies-contact-form", {
        staticClass: "pb-5 pb-xl-0",
        staticStyle: {
          "margin-top": "0px !important",
          "padding-top": "3rem !important"
        },
        attrs: {
          forCompaniesOnly: "",
          hideWebsite: "",
          showReason: "",
          subtitle: _vm.$t("os360-empresas.opensalud-empresas.form-subtitle"),
          callbackPath: "/opensalud360/empresas/gracias"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14e697a9", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/48.51575ad440285e0c5e3a.js